import React from "react";
import {KTMScreen} from "ktm-ui";
import "bootstrap/dist/css/bootstrap.min.css";
import toastr from "toastr";
import axios from "axios";
import {Bar, BarChart, CartesianGrid, Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis,} from "recharts";
import {Button, Spinner} from "react-bootstrap";
import CustomToolTip from "components/CustomToolTip";
import InfoBox from "components/InfoBox";
import {CustomDateRangePicker} from "components/CustomDateRangePicker";
import OpsFinancialsReport from "./Reports/OpsFinancialsReport";
import LeadershipMetricsReport from "./Reports/LeadershipMetricsReport";
import AdjudicationSlaReport from "./Reports/AdjudicationSlaReport";
import CustomPagination from "../components/CustomPagination";
import {CSVLink} from "react-csv";
import {ClipboardList, Users, FileText, TrendingUp, BarChart3, Clock, ImageIcon, CheckCircle, DollarSign, Download, ChevronDown, ChevronRight} from "lucide-react";
import JSZip from "jszip";

const SALES_AGGREGATE_REGION_LABELS: Record<string, string> = {
    REG1: "Region 1",
    REG2: "Region 2",
    REG3: "Region 3",
};

function toLocalDateParam(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

function formatCurrency(n: number): string {
    return "$" + (n ?? 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function formatCount(n: number): string {
    return (n ?? 0).toLocaleString("en-US");
}

export default KTMScreen(
    {name: "dashboardreport"},
    class extends React.Component<any, any> {
        state = {
            loadingPolicySummary: true,
            loadingPolicyReports: true,
            loadingDaily: true,
            loadingClaims: true,
            loadingAdvisorReports: true,
            reportDaily: null,
            reportClaims: null,
            fromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            toDate: new Date(),
            currentTab: "adjudication",
            mountedTabs: {},
            adjudicatorViewMode: "table",
            adjudicatorSortColumn: "name",
            adjudicatorSortDirection: "asc",
            reportPolicySummary: null,
            reportPolicyReports: null,
            expandedContestCode: null,
            contestDetailRows: [],
            loadingContestDetail: false,
            contestAdvisorSummary: [],
            reportAdvisors: null,
            currentPageAdvisorPolicy: 1,
            advisorPolicyItemsPerPage: 10,
            sortColumn: null,
            sortDirection: null,
            advisorPolicyList: [],
            enrollmentDropdown: "ALL",
            enrollmentFromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            enrollmentToDate: new Date(),
            userRole: null,
            userValidated: false,
            advisorFromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            advisorToDate: new Date(),
            showAdvisorYtd: false,
            advisorTypeFilter: "jgOnly",
            distroSearchFilter: '',
            groupByDistro: true,
            loadingReactivation: true,
            reactivationList: [],
            reactivationSortColumn: null,
            reactivationSortDirection: null,
            currentPageReactivation: 1,
            reactivationItemsPerPage: 10,
            reactivationStatusFilter: "ALL",
            reactivationMonthsFilter: "ALL",
            loadingAdminFee: true,
            adminFeeData: [],
            adminFeeTotalNHC: 0,
            adminFeeTotalSales: 0,
            adminFeeTotalCombined: 0,
            adminFeeFilterYear: new Date().getFullYear(),
            adminFeeFilterMonth: new Date().getMonth() + 1,
            adminFeeFilterRecipient: "ALL",
            adminFeeSortColumn: null,
            adminFeeSortDirection: null,
            currentPageAdminFee: 1,
            adminFeeItemsPerPage: 10,
            exportingAdminFeeZip: false,
            salesRegion: null,
            salesReportData: [],
            loadingSalesReport: true,
            salesReportFilterYear: new Date().getFullYear(),
            salesReportFilterMonth: new Date().getMonth() + 1,
            salesReportSortColumn: null,
            salesReportSortDirection: null,
            currentPageSalesReport: 1,
            salesReportItemsPerPage: 10,
            salesReportTotal: 0,
            salesAggregateFilterYear: new Date().getFullYear(),
            salesAggregateFilterMonth: new Date().getMonth() + 1,
            salesAggregateData: [],
            loadingSalesAggregate: true,
            salesAggregateError: null,
            salesAdminFeeData: [],
            loadingSalesAdminFee: true,
            salesAdminFeeTotalNhc: 0,
            salesAdminFeeTotalDistro: 0,
            salesAdminFeeTotalEnroll: 0,
            salesAdminFeeSortColumn: null,
            salesAdminFeeSortDirection: null,
            currentPageSalesAdminFee: 1,
            salesAdminFeeItemsPerPage: 10,
            salesAdminFeeFromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            salesAdminFeeToDate: new Date(),
            activityReportReg1: 0,
            activityReportReg2: 0,
            activityReportReg3: 0,
            activityReportNoReg: 0,
            reactivationReg1: 0,
            reactivationReg2: 0,
            reactivationReg3: 0,
            reactivationNoReg: 0,
            newAdvisorReg1: 0,
            newAdvisorReg2: 0,
            newAdvisorReg3: 0,
            newAdvisorNoReg: 0,
            noPriorReg1: 0,
            noPriorReg2: 0,
            noPriorReg3: 0,
            noPriorNoReg: 0,
            policyCreatedReg1: 0,
            policyCreatedReg2: 0,
            policyCreatedReg3: 0,
            policyCreatedNoReg: 0,
            loadingActivityReport: true,
            activityReportFilterYear: new Date().getFullYear(),
            activityReportFilterMonth: new Date().getMonth() + 1,
            activityReportUseDateRange: false,
            activityReportFromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            activityReportToDate: new Date(),
            salesReactivationSortColumn: null,
            salesReactivationSortDirection: null,
            currentPageSalesReactivation: 1,
            salesReactivationItemsPerPage: 10,
            salesReactivationStatusFilter: "ALL",
            salesReactivationMonthsFilter: "ALL",
        };

        componentDidMount() {
            this.getFinanceUserRole();
            this.initializeDaily();
            this.initializeClaims();
            this.initializePolicySummary();
            this.initializePolicyReports();
            this.initializeAdvisorReports();
            this.initializeReactivation();
            this.initializeAdminFee();
            this.initializeActivityReport();
            this.initializeSalesAggregate();
        }

        componentDidUpdate(prevProps, prevState) {
            if (prevState.enrollmentDropdown !== this.state.enrollmentDropdown ||
                prevState.enrollmentFromDate !== this.state.enrollmentFromDate ||
                prevState.enrollmentToDate !== this.state.enrollmentToDate
            ) {
                this.setState({loadingPolicySummary: true});
                this.initializePolicySummary();
            }
        }

        getFinanceUserRole() {
            axios.get("/api/PlanAdmin/getfinanceuserrole")
                .then(res => {
                        if (res.data.success) {
                            this.setState({
                                userValidated: true,
                                userRole: res.data.userRole,
                                salesRegion: res.data.salesRegion,
                                currentTab: res.data.userRole === "Sales" ? "salesReports" : "adjudication"
                            }, () => {
                                if (res.data.userRole === "Sales" && res.data.salesRegion) {
                                    this.initializeSalesReport();
                                    this.initializeSalesAdminFee();
                                    this.initializeActivityReport();
                                }
                            });
                        } else {
                            toastr.error(res.data.message, "Error");
                        }
                    }
                )
                .catch(error => {
                    toastr.error(error, "Error");
                });
        }

        setFromDate = (date) => {
            this.setState({
                fromDate: date,
            });
        };

        setToDate = (date) => {
            this.setState({
                toDate: date,
            });
        };

        changeEnrollmentDropdown = (value) => {
            this.setState({enrollmentDropdown: value})
            this.initializePolicySummary();
        }

        setEnrollmentFromDate = (date) => {
            this.setState({
                enrollmentFromDate: date,
            });
        };

        setEnrollmentToDate = (date) => {
            this.setState({
                enrollmentToDate: date,
            });
        };

        setAdvisorFromDate = (date) => {
            this.setState({
                advisorFromDate: date,
            });
        };

        setAdvisorToDate = (date) => {
            this.setState({
                advisorToDate: date,
            });
        };

        applyClaimsFilter = () => {
            this.setState({loadingClaims: true});
            this.initializeClaims();
        };

        toggleAdjudicatorView = () => {
            this.setState((prevState) => ({
                adjudicatorViewMode: prevState.adjudicatorViewMode === "table" ? "chart" : "table"
            }));
        };

        handleAdjudicatorSort = (column) => {
            const {adjudicatorSortColumn, adjudicatorSortDirection} = this.state;
            const direction = adjudicatorSortColumn === column && adjudicatorSortDirection === "asc" ? "desc" : "asc";
            this.setState({
                adjudicatorSortColumn: column,
                adjudicatorSortDirection: direction
            });
        };

        getSortedAdjudicatorTotals = () => {
            const {reportClaims, adjudicatorSortColumn, adjudicatorSortDirection} = this.state;
            if (!reportClaims || !reportClaims.adjudicationTotals) return [];

            return [...reportClaims.adjudicationTotals].sort((a, b) => {
                let aVal = adjudicatorSortColumn === "name" ? a.name : a.totalProcessed;
                let bVal = adjudicatorSortColumn === "name" ? b.name : b.totalProcessed;

                if (typeof aVal === "string") {
                    aVal = aVal.toLowerCase();
                    bVal = bVal.toLowerCase();
                }

                if (aVal < bVal) return adjudicatorSortDirection === "asc" ? -1 : 1;
                if (aVal > bVal) return adjudicatorSortDirection === "asc" ? 1 : -1;
                return 0;
            });
        };

        initializeDaily = () => {
            fetch("/api/opsreport/getadjudicationdaily", {
                method: "GET",
            })
                .then((response) => response.json())
                .then((data) => {
                    this.setState({
                        loadingDaily: false,
                        reportDaily: data.reportDaily,
                    });
                })
                .catch((error) => {
                    this.setState({loadingDaily: false});
                });
        };

        initializeClaims = () => {
            fetch(
                "/api/opsreport/getadjudicationclaims?dateFrom=" +
                toLocalDateParam(this.state.fromDate) +
                "&dateTo=" +
                toLocalDateParam(this.state.toDate),
                {
                    method: "GET",
                }
            )
                .then((response) => response.json())
                .then((data) => {
                    this.setState(
                        {
                            loadingClaims: false,
                            reportClaims: data.reportClaims,
                        },
                    );
                })
                .catch((error) => {
                    this.setState({loadingClaims: false});
                });
        };

        initializePolicySummary = () => {
            var fetch_api = "/api/opsreport/getpolicysummary";
            if (this.state.enrollmentDropdown !== "ALL") {
                fetch_api += "?dateFrom=" + toLocalDateParam(this.state.enrollmentFromDate) +
                    "&dateTo=" + toLocalDateParam(this.state.enrollmentToDate);
            }
            fetch(fetch_api, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((data) => {
                    this.setState({
                        loadingPolicySummary: false,
                        reportPolicySummary: data.policySummary,
                    });
                })
                .catch((error) => {
                    this.setState({loadingPolicySummary: false});
                });
        };

        initializePolicyReports = () => {
            fetch("/api/opsreport/getpolicyreports", {
                method: "GET",
            })
                .then((response) => response.json())
                .then((data) => {
                    this.setState({
                        loadingPolicyReports: false,
                        reportPolicyReports: data.policyReports,
                    });
                })
                .catch((error) => {
                    this.setState({loadingPolicyReports: false});
                });

            fetch("/api/opsreport/getcontestadvisorsummary", {
                method: "GET",
            })
                .then((response) => response.json())
                .then((data) => {
                    this.setState({ contestAdvisorSummary: data.summary || [] });
                })
                .catch((error) => {});
        };
        initializeAdvisorReports = () => {
            this.setState({loadingAdvisorReports: true});
            const jgOnly = this.state.advisorTypeFilter === "jgOnly";
            const url = `/api/opsreport/getadvisorreports?dateFrom=${toLocalDateParam(this.state.advisorFromDate)}&dateTo=${toLocalDateParam(this.state.advisorToDate)}&jgOnly=${jgOnly}`;
            fetch(url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((data) => {
                    this.setState({
                        reportAdvisors: data.advisorReport,
                        loadingAdvisorReports: false,
                        advisorPolicyList: data.advisorReport.advisorPolicyCount,
                        sortColumn: null,
                        sortDirection: null,
                        currentPageAdvisorPolicy: 1,
                    });
                })
                .catch((error) => {
                    this.setState({loadingAdvisorReports: false});
                });
        };

        initializeReactivation = () => {
            this.setState({ loadingReactivation: true });
            fetch("/api/opsreport/getadvisorreactivation", { method: "GET" })
                .then((response) => response.json())
                .then((data) => {
                    this.setState({
                        reactivationList: data.advisorReactivation,
                        loadingReactivation: false,
                        reactivationSortColumn: null,
                        reactivationSortDirection: null,
                        currentPageReactivation: 1,
                    });
                })
                .catch(() => {
                    this.setState({ loadingReactivation: false });
                });
        };

        handleReactivationSort = (column) => {
            const { reactivationSortColumn, reactivationSortDirection, reactivationList } = this.state;
            const direction =
                reactivationSortColumn === column && reactivationSortDirection === 'asc' ? 'desc' : 'asc';
            const sortedData = [...reactivationList].sort((a, b) => {
                let aVal = a[column];
                let bVal = b[column];

                if (aVal == null) aVal = '';
                if (bVal == null) bVal = '';

                if (typeof aVal === 'number' && typeof bVal === 'number') {
                    return direction === 'asc' ? aVal - bVal : bVal - aVal;
                }

                const aStr = String(aVal).toLowerCase();
                const bStr = String(bVal).toLowerCase();

                if (aStr < bStr) return direction === 'asc' ? -1 : 1;
                if (aStr > bStr) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            this.setState({
                reactivationSortColumn: column,
                reactivationSortDirection: direction,
                reactivationList: sortedData,
            });
        };

        getFilteredReactivationList = () => {
            const { reactivationList, reactivationStatusFilter, reactivationMonthsFilter } = this.state;
            return reactivationList.filter(item => {
                if (reactivationStatusFilter !== "ALL" && item.status !== reactivationStatusFilter) return false;
                if (reactivationMonthsFilter === "NEVER" && item.monthsSinceLastEnrollment != null) return false;
                if (reactivationMonthsFilter === "12" && (item.monthsSinceLastEnrollment == null || item.monthsSinceLastEnrollment > 12)) return false;
                if (reactivationMonthsFilter === "24" && (item.monthsSinceLastEnrollment == null || item.monthsSinceLastEnrollment > 24)) return false;
                if (reactivationMonthsFilter === "25+" && (item.monthsSinceLastEnrollment == null || item.monthsSinceLastEnrollment < 25)) return false;
                return true;
            });
        };

        currentReactivationRecords = () => {
            const filtered = this.getFilteredReactivationList();
            const indexOfLastRecord = this.state.currentPageReactivation * this.state.reactivationItemsPerPage;
            const indexOfFirstRecord = indexOfLastRecord - this.state.reactivationItemsPerPage;
            return filtered.slice(indexOfFirstRecord, indexOfLastRecord);
        };

        setReactivationCurrentPage = (val) => {
            this.setState({ currentPageReactivation: val });
        };

        getRegionProvinces = () => {
            switch (this.state.salesRegion) {
                case "REG1": return ["BC", "SK", "MB"];
                case "REG2": return ["AB", "NB", "NS", "PE", "NL"];
                case "REG3": return ["ON"];
                default: return [];
            }
        };

        getSalesFilteredReactivationList = () => {
            const { reactivationList, salesReactivationStatusFilter, salesReactivationMonthsFilter } = this.state;
            const provinces = this.getRegionProvinces();
            return reactivationList.filter(item => {
                if (!provinces.includes(item.province)) return false;
                if (salesReactivationStatusFilter !== "ALL" && item.status !== salesReactivationStatusFilter) return false;
                if (salesReactivationMonthsFilter === "NEVER" && item.monthsSinceLastEnrollment != null) return false;
                if (salesReactivationMonthsFilter === "12" && (item.monthsSinceLastEnrollment == null || item.monthsSinceLastEnrollment > 12)) return false;
                if (salesReactivationMonthsFilter === "24" && (item.monthsSinceLastEnrollment == null || item.monthsSinceLastEnrollment > 24)) return false;
                if (salesReactivationMonthsFilter === "25+" && (item.monthsSinceLastEnrollment == null || item.monthsSinceLastEnrollment < 25)) return false;
                return true;
            });
        };

        handleSalesReactivationSort = (column) => {
            const { salesReactivationSortColumn, salesReactivationSortDirection } = this.state;
            const direction =
                salesReactivationSortColumn === column && salesReactivationSortDirection === 'asc' ? 'desc' : 'asc';
            this.setState({
                salesReactivationSortColumn: column,
                salesReactivationSortDirection: direction,
            });
        };

        currentSalesReactivationRecords = () => {
            const filtered = this.getSalesFilteredReactivationList();
            const { salesReactivationSortColumn, salesReactivationSortDirection } = this.state;
            let sorted = filtered;
            if (salesReactivationSortColumn) {
                sorted = [...filtered].sort((a, b) => {
                    let aVal = a[salesReactivationSortColumn];
                    let bVal = b[salesReactivationSortColumn];
                    if (aVal == null) aVal = '';
                    if (bVal == null) bVal = '';
                    if (typeof aVal === 'number' && typeof bVal === 'number') {
                        return salesReactivationSortDirection === 'asc' ? aVal - bVal : bVal - aVal;
                    }
                    const aStr = String(aVal).toLowerCase();
                    const bStr = String(bVal).toLowerCase();
                    if (aStr < bStr) return salesReactivationSortDirection === 'asc' ? -1 : 1;
                    if (aStr > bStr) return salesReactivationSortDirection === 'asc' ? 1 : -1;
                    return 0;
                });
            }
            const indexOfLastRecord = this.state.currentPageSalesReactivation * this.state.salesReactivationItemsPerPage;
            const indexOfFirstRecord = indexOfLastRecord - this.state.salesReactivationItemsPerPage;
            return sorted.slice(indexOfFirstRecord, indexOfLastRecord);
        };

        setSalesReactivationCurrentPage = (val) => {
            this.setState({ currentPageSalesReactivation: val });
        };

        initializeAdminFee = () => {
            this.setState({ loadingAdminFee: true });
            fetch(
                `/api/opstransfer/getadminfeereportbymonth?year=${this.state.adminFeeFilterYear}&month=${this.state.adminFeeFilterMonth}&recipientFilter=${this.state.adminFeeFilterRecipient}`,
                { method: "GET" }
            )
                .then((response) => response.json())
                .then((data) => {
                    this.setState({
                        adminFeeData: data.data,
                        adminFeeTotalNHC: data.totals.totalNHC || 0,
                        adminFeeTotalSales: data.totals.totalSales || 0,
                        adminFeeTotalCombined: data.totals.totalCombined || 0,
                        loadingAdminFee: false,
                        currentPageAdminFee: 1,
                        adminFeeSortColumn: null,
                        adminFeeSortDirection: null,
                    });
                })
                .catch(() => {
                    this.setState({
                        adminFeeData: [],
                        adminFeeTotalNHC: 0,
                        adminFeeTotalSales: 0,
                        adminFeeTotalCombined: 0,
                        loadingAdminFee: false,
                    });
                });
        };

        setActivityReportFromDate = (date) => {
            this.setState({ activityReportFromDate: date });
        };

        setActivityReportToDate = (date) => {
            this.setState({ activityReportToDate: date });
        };

        setActivityReportMode = (useDateRange: boolean) => {
            if (!useDateRange) {
                this.setState({ activityReportUseDateRange: false });
                return;
            }
            const { activityReportFilterYear, activityReportFilterMonth } = this.state;
            this.setState({
                activityReportUseDateRange: true,
                activityReportFromDate: new Date(activityReportFilterYear, activityReportFilterMonth - 1, 1),
                activityReportToDate: new Date(activityReportFilterYear, activityReportFilterMonth, 0),
            });
        };

        activityReportParams = () => {
            const {
                activityReportFilterYear,
                activityReportFilterMonth,
                activityReportUseDateRange,
                activityReportFromDate,
                activityReportToDate,
            } = this.state;

            const params = `year=${activityReportFilterYear}&month=${activityReportFilterMonth}`;
            if (!activityReportUseDateRange) return params;

            return `${params}&dateFrom=${toLocalDateParam(activityReportFromDate)}&dateTo=${toLocalDateParam(activityReportToDate)}`;
        };

        activityReportPeriodLabel = () => {
            const {
                activityReportFilterYear,
                activityReportFilterMonth,
                activityReportUseDateRange,
                activityReportFromDate,
                activityReportToDate,
            } = this.state;

            if (!activityReportUseDateRange) return `${activityReportFilterYear}_${activityReportFilterMonth}`;

            return `${toLocalDateParam(activityReportFromDate)}_to_${toLocalDateParam(activityReportToDate)}`;
        };

        renderActivityReportFilters = () => {
            return (
                <>
                    <div className="d-flex align-items-center gap-2">
                        <label className="mb-0">Filter by:</label>
                        <select
                            className="form-select"
                            style={{ width: 'auto' }}
                            value={this.state.activityReportUseDateRange ? "range" : "month"}
                            onChange={(e) => this.setActivityReportMode(e.target.value === "range")}
                        >
                            <option value="month">Month</option>
                            <option value="range">Date Range</option>
                        </select>
                    </div>
                    {this.state.activityReportUseDateRange ? (
                        <div className="d-flex align-items-center gap-2">
                            <CustomDateRangePicker
                                fromDate={this.state.activityReportFromDate}
                                toDate={this.state.activityReportToDate}
                                setFromDate={this.setActivityReportFromDate}
                                setToDate={this.setActivityReportToDate}
                            />
                        </div>
                    ) : (
                        <>
                            <div className="d-flex align-items-center gap-2">
                                <label className="mb-0">Month:</label>
                                <select
                                    className="form-select"
                                    style={{ width: 'auto' }}
                                    value={this.state.activityReportFilterMonth}
                                    onChange={(e) => this.setState({ activityReportFilterMonth: parseInt(e.target.value) })}
                                >
                                    {Array.from({ length: 12 }, (_, i) => (
                                        <option key={i + 1} value={i + 1}>
                                            {new Date(0, i).toLocaleString("default", { month: "long" })}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <label className="mb-0">Year:</label>
                                <select
                                    className="form-select"
                                    style={{ width: 'auto' }}
                                    value={this.state.activityReportFilterYear}
                                    onChange={(e) => this.setState({ activityReportFilterYear: parseInt(e.target.value) })}
                                >
                                    {Array.from({ length: new Date().getFullYear() - 2020 + 1 }, (_, i) => (
                                        <option key={new Date().getFullYear() - i} value={new Date().getFullYear() - i}>
                                            {new Date().getFullYear() - i}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </>
                    )}
                    <div className="d-flex align-items-center gap-2">
                        <Button variant="primary" size="sm" onClick={() => this.initializeActivityReport()}>
                            Submit
                        </Button>
                    </div>
                </>
            );
        };

        initializeActivityReport = () => {
            this.setState({ loadingActivityReport: true });
            fetch(
                `/api/opsreport/getactivityreport?${this.activityReportParams()}`,
                { method: "GET" }
            )
                .then((response) => response.json())
                .then((data) => {
                    this.setState({
                        activityReportReg1: data.reg1 || 0,
                        activityReportReg2: data.reg2 || 0,
                        activityReportReg3: data.reg3 || 0,
                        activityReportNoReg: data.noReg || 0,
                        reactivationReg1: data.reactivationReg1 || 0,
                        reactivationReg2: data.reactivationReg2 || 0,
                        reactivationReg3: data.reactivationReg3 || 0,
                        reactivationNoReg: data.reactivationNoReg || 0,
                        newAdvisorReg1: data.newAdvisorReg1 || 0,
                        newAdvisorReg2: data.newAdvisorReg2 || 0,
                        newAdvisorReg3: data.newAdvisorReg3 || 0,
                        newAdvisorNoReg: data.newAdvisorNoReg || 0,
                        noPriorReg1: data.noPriorReg1 || 0,
                        noPriorReg2: data.noPriorReg2 || 0,
                        noPriorReg3: data.noPriorReg3 || 0,
                        noPriorNoReg: data.noPriorNoReg || 0,
                        policyCreatedReg1: data.policyCreatedReg1 || 0,
                        policyCreatedReg2: data.policyCreatedReg2 || 0,
                        policyCreatedReg3: data.policyCreatedReg3 || 0,
                        policyCreatedNoReg: data.policyCreatedNoReg || 0,
                        loadingActivityReport: false,
                    });
                })
                .catch(() => {
                    this.setState({
                        activityReportReg1: 0,
                        activityReportReg2: 0,
                        activityReportReg3: 0,
                        activityReportNoReg: 0,
                        reactivationReg1: 0,
                        reactivationReg2: 0,
                        reactivationReg3: 0,
                        reactivationNoReg: 0,
                        newAdvisorReg1: 0,
                        newAdvisorReg2: 0,
                        newAdvisorReg3: 0,
                        newAdvisorNoReg: 0,
                        noPriorReg1: 0,
                        noPriorReg2: 0,
                        noPriorReg3: 0,
                        noPriorNoReg: 0,
                        policyCreatedReg1: 0,
                        policyCreatedReg2: 0,
                        policyCreatedReg3: 0,
                        policyCreatedNoReg: 0,
                        loadingActivityReport: false,
                    });
                });
        };

        toggleContestDetail = async (contestCode: string) => {
            if (this.state.expandedContestCode === contestCode) {
                this.setState({ expandedContestCode: null, contestDetailRows: [] });
                return;
            }

            this.setState({ expandedContestCode: contestCode, loadingContestDetail: true, contestDetailRows: [] });
            const res = await fetch(
                `/api/opsreport/getcontestpolicydetail?contestCode=${encodeURIComponent(contestCode)}`
            );
            const json = await res.json();
            this.setState({ contestDetailRows: json.detail || [], loadingContestDetail: false });
        };

        downloadContestDetail = async (contestCode: string) => {
            const res = await fetch(
                `/api/opsreport/getcontestpolicydetail?contestCode=${encodeURIComponent(contestCode)}`
            );
            const json = await res.json();
            const rows = json.detail || [];
            if (!rows.length) return;

            const headers = ["Policy No", "Company", "Primary Advisor", "Province", "Contest Code", "Policy Created At"];
            const csvRows = [headers.join(",")];
            for (const row of rows) {
                const created = row.createdAt ? new Date(row.createdAt).toLocaleDateString() : "";
                const vals = [row.policyNo, row.name, row.primaryAdvisor, row.province, row.contestCode, created];
                csvRows.push(vals.map(v => {
                    const str = String(v ?? "");
                    return str.includes(",") || str.includes('"') ? `"${str.replace(/"/g, '""')}"` : str;
                }).join(","));
            }

            const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `contest_${contestCode}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        };

        downloadActivityDetail = async (type: string, label: string) => {
            const res = await fetch(
                `/api/opsreport/getactivityreportdetail?${this.activityReportParams()}&type=${type}`
            );
            const json = await res.json();
            if (!json.success || !json.data?.length) return;

            const headers = Object.keys(json.data[0]);
            const csvRows = [headers.join(",")];
            for (const row of json.data) {
                csvRows.push(headers.map(h => {
                    const val = row[h] ?? "";
                    const str = String(val);
                    return str.includes(",") || str.includes('"') ? `"${str.replace(/"/g, '""')}"` : str;
                }).join(","));
            }

            const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${label}_${this.activityReportPeriodLabel()}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        };

        downloadActivityDetailFiltered = async (type: string, label: string) => {
            const { salesRegion } = this.state;
            const regionNameMap = { REG1: "Region 1", REG2: "Region 2", REG3: "Region 3" };
            const regionDisplayName = regionNameMap[salesRegion] || salesRegion;

            const res = await fetch(
                `/api/opsreport/getactivityreportdetail?${this.activityReportParams()}&type=${type}`
            );
            const json = await res.json();
            if (!json.success || !json.data?.length) return;

            const filtered = json.data.filter(row => row.Region === regionDisplayName);
            if (!filtered.length) return;

            const headers = Object.keys(filtered[0]);
            const csvRows = [headers.join(",")];
            for (const row of filtered) {
                csvRows.push(headers.map(h => {
                    const val = row[h] ?? "";
                    const str = String(val);
                    return str.includes(",") || str.includes('"') ? `"${str.replace(/"/g, '""')}"` : str;
                }).join(","));
            }

            const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${label}_${regionDisplayName.replace(/\s/g, "_")}_${this.activityReportPeriodLabel()}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        };

        handleAdminFeeSort = (column) => {
            const { adminFeeSortColumn, adminFeeSortDirection, adminFeeData } = this.state;
            const direction =
                adminFeeSortColumn === column && adminFeeSortDirection === 'asc' ? 'desc' : 'asc';
            const sortedData = [...adminFeeData].sort((a, b) => {
                let aVal = a[column];
                let bVal = b[column];

                if (aVal == null) aVal = '';
                if (bVal == null) bVal = '';

                if (typeof aVal === 'number' && typeof bVal === 'number') {
                    return direction === 'asc' ? aVal - bVal : bVal - aVal;
                }

                const aStr = String(aVal).toLowerCase();
                const bStr = String(bVal).toLowerCase();

                if (aStr < bStr) return direction === 'asc' ? -1 : 1;
                if (aStr > bStr) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            this.setState({
                adminFeeSortColumn: column,
                adminFeeSortDirection: direction,
                adminFeeData: sortedData,
            });
        };

        currentAdminFeeRecords = () => {
            const indexOfLastRecord = this.state.currentPageAdminFee * this.state.adminFeeItemsPerPage;
            const indexOfFirstRecord = indexOfLastRecord - this.state.adminFeeItemsPerPage;
            return this.state.adminFeeData.slice(indexOfFirstRecord, indexOfLastRecord);
        };

        setAdminFeeCurrentPage = (val) => {
            this.setState({ currentPageAdminFee: val });
        };

        initializeSalesAggregate = () => {
            this.setState({ loadingSalesAggregate: true, salesAggregateError: null });
            fetch(
                `/api/opstransfer/getsalesaggregatereport?year=${this.state.salesAggregateFilterYear}&month=${this.state.salesAggregateFilterMonth}`,
                { method: "GET" }
            )
                .then((response) => response.json())
                .then((data) => {
                    if (data.success) {
                        this.setState({
                            salesAggregateData: data.rows || [],
                            loadingSalesAggregate: false,
                        });
                    } else {
                        this.setState({
                            salesAggregateData: [],
                            loadingSalesAggregate: false,
                            salesAggregateError: data.message || "Failed to load aggregate report",
                        });
                    }
                })
                .catch((err) => {
                    this.setState({
                        salesAggregateData: [],
                        loadingSalesAggregate: false,
                        salesAggregateError: err.message || "Failed to load aggregate report",
                    });
                });
        };

        initializeSalesReport = () => {
            this.setState({ loadingSalesReport: true });
            fetch(
                `/api/opstransfer/getadminfeereportbymonth?year=${this.state.salesReportFilterYear}&month=${this.state.salesReportFilterMonth}&recipientFilter=${this.state.salesRegion}`,
                { method: "GET" }
            )
                .then((response) => response.json())
                .then((data) => {
                    this.setState({
                        salesReportData: data.data,
                        salesReportTotal: data.totals.totalCombined || 0,
                        loadingSalesReport: false,
                        currentPageSalesReport: 1,
                        salesReportSortColumn: null,
                        salesReportSortDirection: null,
                    });
                })
                .catch(() => {
                    this.setState({
                        salesReportData: [],
                        salesReportTotal: 0,
                        loadingSalesReport: false,
                    });
                });
        };

        handleSalesReportSort = (column) => {
            const { salesReportSortColumn, salesReportSortDirection, salesReportData } = this.state;
            const direction =
                salesReportSortColumn === column && salesReportSortDirection === 'asc' ? 'desc' : 'asc';
            const sortedData = [...salesReportData].sort((a, b) => {
                let aVal = a[column];
                let bVal = b[column];

                if (aVal == null) aVal = '';
                if (bVal == null) bVal = '';

                if (typeof aVal === 'number' && typeof bVal === 'number') {
                    return direction === 'asc' ? aVal - bVal : bVal - aVal;
                }

                const aStr = String(aVal).toLowerCase();
                const bStr = String(bVal).toLowerCase();

                if (aStr < bStr) return direction === 'asc' ? -1 : 1;
                if (aStr > bStr) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            this.setState({
                salesReportSortColumn: column,
                salesReportSortDirection: direction,
                salesReportData: sortedData,
            });
        };

        currentSalesReportRecords = () => {
            const indexOfLastRecord = this.state.currentPageSalesReport * this.state.salesReportItemsPerPage;
            const indexOfFirstRecord = indexOfLastRecord - this.state.salesReportItemsPerPage;
            return this.state.salesReportData.slice(indexOfFirstRecord, indexOfLastRecord);
        };

        setSalesReportCurrentPage = (val) => {
            this.setState({ currentPageSalesReport: val });
        };

        initializeSalesAdminFee = () => {
            this.setState({ loadingSalesAdminFee: true });
            fetch(
                `/api/opstransfer/getadminfeereport?dateFrom=${toLocalDateParam(this.state.salesAdminFeeFromDate)}&dateTo=${toLocalDateParam(this.state.salesAdminFeeToDate)}`,
                { method: "GET" }
            )
                .then((response) => response.json())
                .then((data) => {
                    this.setState({
                        salesAdminFeeData: data.adminFees || [],
                        salesAdminFeeTotalNhc: data.totalNhc || 0,
                        salesAdminFeeTotalDistro: data.totalDistro || 0,
                        salesAdminFeeTotalEnroll: data.totalEnroll || 0,
                        loadingSalesAdminFee: false,
                        currentPageSalesAdminFee: 1,
                        salesAdminFeeSortColumn: null,
                        salesAdminFeeSortDirection: null,
                    });
                })
                .catch(() => {
                    this.setState({
                        salesAdminFeeData: [],
                        salesAdminFeeTotalNhc: 0,
                        salesAdminFeeTotalDistro: 0,
                        salesAdminFeeTotalEnroll: 0,
                        loadingSalesAdminFee: false,
                    });
                });
        };

        handleSalesAdminFeeSort = (column) => {
            const { salesAdminFeeSortColumn, salesAdminFeeSortDirection, salesAdminFeeData } = this.state;
            const direction =
                salesAdminFeeSortColumn === column && salesAdminFeeSortDirection === 'asc' ? 'desc' : 'asc';
            const sortedData = [...salesAdminFeeData].sort((a, b) => {
                let aVal = a[column];
                let bVal = b[column];

                if (aVal == null) aVal = '';
                if (bVal == null) bVal = '';

                if (typeof aVal === 'number' && typeof bVal === 'number') {
                    return direction === 'asc' ? aVal - bVal : bVal - aVal;
                }

                const aStr = String(aVal).toLowerCase();
                const bStr = String(bVal).toLowerCase();

                if (aStr < bStr) return direction === 'asc' ? -1 : 1;
                if (aStr > bStr) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            this.setState({
                salesAdminFeeSortColumn: column,
                salesAdminFeeSortDirection: direction,
                salesAdminFeeData: sortedData,
            });
        };

        currentSalesAdminFeeRecords = () => {
            const indexOfLastRecord = this.state.currentPageSalesAdminFee * this.state.salesAdminFeeItemsPerPage;
            const indexOfFirstRecord = indexOfLastRecord - this.state.salesAdminFeeItemsPerPage;
            return this.state.salesAdminFeeData.slice(indexOfFirstRecord, indexOfLastRecord);
        };

        setSalesAdminFeeCurrentPage = (val) => {
            this.setState({ currentPageSalesAdminFee: val });
        };

        setSalesAdminFeeFromDate = (date) => {
            this.setState({ salesAdminFeeFromDate: date }, () => {
                this.initializeSalesAdminFee();
            });
        };

        setSalesAdminFeeToDate = (date) => {
            this.setState({ salesAdminFeeToDate: date }, () => {
                this.initializeSalesAdminFee();
            });
        };

        exportAdminFeeAllRegions = async () => {
            this.setState({ exportingAdminFeeZip: true });
            const { adminFeeFilterYear, adminFeeFilterMonth, adminFeeFilterRecipient, adminFeeData } = this.state;

            const csvHeaders = "Trans Date,Enroll Date,Policy,Policy Province,Claim No.,Total Approved,Policy Active Months,Recipient,Amount";
            const csvKeys = ["transDate", "createdAt", "name", "taxJurisdictionId", "claimNo", "totalApproved", "policyActiveMonths", "recipientType", "transAmount"];

            const toCsvString = (rows) => {
                if (!rows || rows.length === 0) return "";
                const lines = [csvHeaders];
                for (let i = 0; i < rows.length; i++) {
                    const row = rows[i];
                    lines.push(csvKeys.map(k => {
                        const val = row[k] != null ? String(row[k]) : "";
                        return val.includes(",") ? `"${val}"` : val;
                    }).join(","));
                }
                return lines.join("\n");
            };

            try {
                let allData = adminFeeData;
                if (adminFeeFilterRecipient !== "ALL") {
                    const res = await fetch(`/api/opstransfer/getadminfeereportbymonth?year=${adminFeeFilterYear}&month=${adminFeeFilterMonth}&recipientFilter=ALL`);
                    const json = await res.json();
                    allData = json.data || [];
                }

                const zip = new JSZip();
                const regions = [
                    { filename: "Revenue_All", filter: null },
                    { filename: "Revenue_Region1", filter: "REG1" },
                    { filename: "Revenue_Region2", filter: "REG2" },
                    { filename: "Revenue_Region3", filter: "REG3" },
                ];

                for (const region of regions) {
                    const rows = region.filter ? allData.filter(r => r.recipientType === region.filter) : allData;
                    if (rows.length > 0) {
                        zip.file(`${region.filename}.csv`, toCsvString(rows));
                    }
                }

                const blob = await zip.generateAsync({ type: "blob" });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `Revenue_${adminFeeFilterYear}_${String(adminFeeFilterMonth).padStart(2, "0")}.zip`;
                a.click();
                // delay revoke so browser can grab the blob
                setTimeout(() => URL.revokeObjectURL(url), 1000);
            } catch {
                toastr.error("Failed to export regions", "Error");
            }
            this.setState({ exportingAdminFeeZip: false });
        };

        setTab = (val) => {
            this.setState(prev => ({
                currentTab: val,
                mountedTabs: {...prev.mountedTabs, [val]: true},
            }));
        };

        getFilteredAdvisorPolicyList = () => {
            const search = this.state.distroSearchFilter.toLowerCase();
            if (!search) return this.state.advisorPolicyList;
            return this.state.advisorPolicyList.filter(
                item => item.distroName?.toLowerCase().includes(search)
            );
        };

        getGroupedByDistroList = () => {
            const filtered = this.getFilteredAdvisorPolicyList();
            if (!this.state.groupByDistro) return filtered;
            const grouped = new Map<string, any>();
            filtered.forEach(item => {
                const key = item.distroName || '';
                if (!grouped.has(key)) {
                    grouped.set(key, {
                        distroName: item.distroName,
                        distroProvince: item.distroProvince,
                        activePolicies: 0,
                        policiesAdded: 0,
                        totalClaimsPaid: 0,
                        newPolicyClaimsPaid: 0,
                        advisorCommission: 0,
                    });
                }
                const row = grouped.get(key);
                row.activePolicies += item.activePolicies ?? 0;
                row.policiesAdded += item.policiesAdded ?? 0;
                row.totalClaimsPaid += (item.totalClaimsPaid ?? 0);
                row.newPolicyClaimsPaid += (item.newPolicyClaimsPaid ?? 0);
                row.advisorCommission += (item.advisorCommission ?? 0);
            });
            const result = Array.from(grouped.values());
            const {sortColumn, sortDirection} = this.state;
            if (sortColumn) {
                result.sort((a, b) => {
                    let aVal = a[sortColumn];
                    let bVal = b[sortColumn];
                    if (aVal == null) aVal = '';
                    if (bVal == null) bVal = '';
                    if (typeof aVal === 'number' && typeof bVal === 'number') {
                        return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
                    }
                    const aStr = String(aVal).toLowerCase();
                    const bStr = String(bVal).toLowerCase();
                    if (aStr < bStr) return sortDirection === 'asc' ? -1 : 1;
                    if (aStr > bStr) return sortDirection === 'asc' ? 1 : -1;
                    return 0;
                });
            }
            return result;
        };

        currentAdvisorPolicyRecords = () => {
            const list = this.getGroupedByDistroList();
            const indexOfLastRecord = this.state.currentPageAdvisorPolicy * this.state.advisorPolicyItemsPerPage;
            const indexOfFirstRecord = indexOfLastRecord - this.state.advisorPolicyItemsPerPage;
            return list.slice(indexOfFirstRecord, indexOfLastRecord);
        };

        nPages = (recordCountLength, itemsPerPage) => {
            return Math.ceil(recordCountLength / itemsPerPage);
        }

        setAdvisorPolicyCurrentPage = (val) => {
            this.setState({currentPageAdvisorPolicy: val})
        }

        handleSort = (column) => {
            const {sortColumn, sortDirection, advisorPolicyList} = this.state;
            const direction =
                sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
            const sortedData = [...advisorPolicyList].sort((a, b) => {
                let aVal = a[column];
                let bVal = b[column];

                // Handle null/undefined values
                if (aVal == null) aVal = '';
                if (bVal == null) bVal = '';

                // Handle numeric values
                if (typeof aVal === 'number' && typeof bVal === 'number') {
                    return direction === 'asc' ? aVal - bVal : bVal - aVal;
                }

                // Handle string values (case-insensitive)
                const aStr = String(aVal).toLowerCase();
                const bStr = String(bVal).toLowerCase();

                if (aStr < bStr) return direction === 'asc' ? -1 : 1;
                if (aStr > bStr) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            this.setState({
                sortColumn: column,
                sortDirection: direction,
                advisorPolicyList: sortedData,
            });
        };

        render() {
            let accountTypeChart = [];
            let zeroPaidChart = [];
            let adjudicationTotalsChart = [];
            if (this.state.reportClaims != null) {
                accountTypeChart = [
                    {name: "HSA", value: this.state.reportClaims.totalPaidHsa},
                    {name: "LSA", value: this.state.reportClaims.totalPaidLsa},
                ];
                zeroPaidChart = [
                    {name: "Paid", value: this.state.reportClaims.paidCount},
                    {name: "$0 Paid", value: this.state.reportClaims.paidZeroCount},
                ];
                adjudicationTotalsChart = this.state.reportClaims.adjudicationTotals;
            }

            const pieColors = ["#1e85e5", "#059454"];
            const zeroPaidColors = ["#059454", "#838383"];

            const accountTypeRadian = Math.PI / 180;
            const renderCustomizedLabel = ({
                                               cx,
                                               cy,
                                               midAngle,
                                               innerRadius,
                                               outerRadius,
                                               percent,
                                               index,
                                           }) => {
                const radius = innerRadius + (outerRadius - innerRadius) * 0.4;
                const x = cx + radius * Math.cos(-midAngle * accountTypeRadian);
                const y = cy + radius * Math.sin(-midAngle * accountTypeRadian);

                let name = "HSA";
                if (index == 1) {
                    name = "LSA";
                }

                return (
                    <text
                        x={x}
                        y={y}
                        fill="white"
                        textAnchor={x > cx ? "start" : "end"}
                        dominantBaseline="central"
                    >
                        {name + ` ${(percent * 100).toFixed(0)}%`}
                    </text>
                );
            };
            const renderZeroPaidLabel = ({
                                             cx,
                                             cy,
                                             midAngle,
                                             innerRadius,
                                             outerRadius,
                                             percent,
                                             index,
                                         }) => {
                const radius = innerRadius + (outerRadius - innerRadius) * 0.4;
                const x = cx + radius * Math.cos(-midAngle * accountTypeRadian);
                const y = cy + radius * Math.sin(-midAngle * accountTypeRadian);

                let name = "Paid";
                if (index == 1) {
                    name = "$0 Paid";
                }

                return (
                    <text
                        x={x}
                        y={y}
                        fill="white"
                        textAnchor={x > cx ? "start" : "end"}
                        dominantBaseline="central"
                    >
                        {name + ` ${(percent * 100).toFixed(0)}%`}
                    </text>
                );
            };

            let distributionData = null;
            if (this.state.reportPolicyReports != null) {
                distributionData = [
                    {
                        name: "1 Employee",
                        Companies:
                        this.state.reportPolicyReports.employeeDistribution.batch1,
                    },
                    {
                        name: "2-10 Employees",
                        Companies:
                        this.state.reportPolicyReports.employeeDistribution.batch2,
                    },
                    {
                        name: "11-50 Employees",
                        Companies:
                        this.state.reportPolicyReports.employeeDistribution.batch3,
                    },
                    {
                        name: "50+ Employees",
                        Companies:
                        this.state.reportPolicyReports.employeeDistribution.batch4,
                    },
                ];
            }

            let provinceTable = null;
            let provincePie = null;
            if (
                this.state.reportPolicyReports != null &&
                this.state.reportPolicyReports.provinceCount.length > 0
            ) {
                const COLORS = [
                    "#8884d8",
                    "#82ca9d",
                    "#FFBB28",
                    "#FF8042",
                    "#AF19FF",
                    "#FF5733",
                    "#33FF57",
                    "#5733FF",
                    "#FF3399",
                    "#33FF99",
                ];
                const provinceData = this.state.reportPolicyReports.provinceCount.map(
                    (item, index) => ({
                        name: item.province,
                        value: item.count,
                        label: item.province,
                        color: COLORS[index % COLORS.length],
                    })
                );

                provincePie = (
                    <div className="chart-container">
                        <ResponsiveContainer width="100%" height={400}>
                            <PieChart>
                                <Pie
                                    data={provinceData}
                                    color="#000000"
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    labelLine={true}
                                    outerRadius={150}
                                    fill="#8884d8"
                                >
                                    {provinceData.map((entry, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={COLORS[index % COLORS.length]}
                                        />
                                    ))}
                                </Pie>
                                <Tooltip/>
                                <Legend layout="horizontal" verticalAlign="bottom" align="center"/>
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                );

                provinceTable = (
                    <div className="dashboard-table-container">
                        <table className="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th style={{width: "75%"}}>Province</th>
                                <th style={{width: "25%"}}>Companies</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.reportPolicyReports.provinceCount.map(
                                (data, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{data.province}</td>
                                            <td>{data.count}</td>
                                        </tr>
                                    );
                                }
                            )}
                            </tbody>
                        </table>
                    </div>
                );
            }

            let contestCodeTable = null;
            if (
                this.state.reportPolicyReports != null &&
                this.state.reportPolicyReports.contestCodeCount != null &&
                this.state.reportPolicyReports.contestCodeCount.length > 0
            ) {
                contestCodeTable = (
                    <div className="dashboard-table-container">
                        <table className="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th style={{width: "55%"}}>Contest Code</th>
                                <th style={{width: "20%"}}># Policies</th>
                                <th style={{width: "25%"}}></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.reportPolicyReports.contestCodeCount.map(
                                (data, index) => {
                                    const isExpanded = this.state.expandedContestCode === data.contestCode;
                                    return (
                                        <React.Fragment key={index}>
                                            <tr>
                                                <td
                                                    onClick={() => this.toggleContestDetail(data.contestCode)}
                                                    style={{cursor: "pointer", userSelect: "none"}}
                                                    title={isExpanded ? "Hide policies" : "Show policies"}
                                                >
                                                    <span className="d-inline-flex align-items-center" style={{gap: "6px", fontWeight: 500, color: "#0d6efd"}}>
                                                        {isExpanded
                                                            ? <ChevronDown size={16}/>
                                                            : <ChevronRight size={16}/>}
                                                        {data.contestCode}
                                                    </span>
                                                </td>
                                                <td>{data.count}</td>
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center"
                                                        style={{gap: "6px"}}
                                                        onClick={() => this.downloadContestDetail(data.contestCode)}
                                                        title="Download CSV"
                                                    >
                                                        <Download size={14}/>
                                                        CSV
                                                    </button>
                                                </td>
                                            </tr>
                                            {isExpanded && (
                                                <tr>
                                                    <td colSpan={3} style={{padding: 0}}>
                                                        {this.state.loadingContestDetail ? (
                                                            <div className="p-2">Loading…</div>
                                                        ) : (
                                                            <table className="table table-sm mb-0">
                                                                <thead>
                                                                <tr>
                                                                    <th>Policy No</th>
                                                                    <th>Company</th>
                                                                    <th>Primary Advisor</th>
                                                                    <th>Province</th>
                                                                    <th>Policy Created At</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {this.state.contestDetailRows.map((row, i) => (
                                                                    <tr key={i}>
                                                                        <td>{row.policyNo}</td>
                                                                        <td>{row.name}</td>
                                                                        <td>{row.primaryAdvisor}</td>
                                                                        <td>{row.province}</td>
                                                                        <td>{row.createdAt ? new Date(row.createdAt).toLocaleDateString() : ""}</td>
                                                                    </tr>
                                                                ))}
                                                                </tbody>
                                                            </table>
                                                        )}
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                }
                            )}
                            </tbody>
                        </table>
                    </div>
                );
            }

            let contestAdvisorTable = null;
            if (this.state.contestAdvisorSummary != null && this.state.contestAdvisorSummary.length > 0) {
                contestAdvisorTable = (
                    <div className="dashboard-table-container">
                        <table className="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th>Primary Advisor</th>
                                <th>Province</th>
                                <th># Contest Policies</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.contestAdvisorSummary.map((row, index) => (
                                <tr key={index}>
                                    <td>{row.primaryAdvisor}</td>
                                    <td>{row.province}</td>
                                    <td>{row.contestPolicyCount}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                );
            }

            let contestMonthlyTable = null;
            if (
                this.state.reportPolicyReports != null &&
                this.state.reportPolicyReports.contestMonthlyCount != null &&
                this.state.reportPolicyReports.contestMonthlyCount.length > 0
            ) {
                contestMonthlyTable = (
                    <div className="dashboard-table-container">
                        <table className="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th style={{width: "60%"}}>Month</th>
                                <th style={{width: "40%"}}># Enrollments</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.reportPolicyReports.contestMonthlyCount.map((row, index) => (
                                <tr key={index}>
                                    <td>{row.month}</td>
                                    <td>{row.count}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                );
            }

            let datePicker = (
                <div className="enrollment-date-picker d-flex" style={{color: "black"}}>
                    <div className="ms-auto">
                        <CustomDateRangePicker
                            fromDate={this.state.enrollmentFromDate}
                            toDate={this.state.enrollmentToDate}
                            setFromDate={this.setEnrollmentFromDate}
                            setToDate={this.setEnrollmentToDate}
                        />
                    </div>
                </div>
            );

            let currentContents = null;
            if (this.state.currentTab == "policy") {
                currentContents = (
                    <div className="card-body">
                        <div className="db-daily">
                            {this.state.loadingPolicySummary ? (
                                <Spinner animation="border"/>
                            ) : (
                                <>
                                    <div className="dashboard-toolbar" style={{background: 'rgba(255,255,255,0.1)', border: 'none'}}>
                                        <div className="dashboard-summary-header" style={{color: '#fff'}}>Enrollments</div>
                                        <div className="ms-auto d-flex align-items-center gap-2">
                                            <select className="form-select"
                                                    value={this.state.enrollmentDropdown}
                                                    style={{maxWidth: '200px'}}
                                                    onChange={(e) => this.changeEnrollmentDropdown(e.target.value)}>
                                                <option value="ALL">Show All</option>
                                                <option value="DATE">Select by Date</option>
                                            </select>
                                        </div>
                                    </div>
                                    {this.state.enrollmentDropdown !== 'ALL' && datePicker}
                                    <div className="row mt-4">
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <FileText size={14}/> POLICIES
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {this.state.reportPolicySummary.totalActive}
                                                </div>
                                                <div>Active Policies</div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <Users size={14}/> GROUP
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {this.state.reportPolicySummary.totalGroup}
                                                </div>
                                                <div>Group Policies</div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <Users size={14}/> OWNERS
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {this.state.reportPolicySummary.totalBusinessOwner}
                                                </div>
                                                <div>Business Owners</div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <Users size={14}/> EMPLOYEES
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {this.state.reportPolicySummary.totalEmployees}
                                                </div>
                                                <div>Active Employees</div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="db-claims">
                            {this.state.loadingPolicyReports ? (
                                <Spinner animation="border"/>
                            ) : (
                                <>
                                    <div className="mb-2 d-flex justify-content-between">
                                        <div className="dashboard-summary-header">
                                            Policies Summary
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <FileText size={14}/> HSA
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {
                                                        this.state.reportPolicyReports.benefitTypeTotals
                                                            .totalHsaOnly
                                                    }
                                                </div>
                                                <div>HSA Only Policies</div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <FileText size={14}/> LSA
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {
                                                        this.state.reportPolicyReports.benefitTypeTotals
                                                            .totalLsaOnly
                                                    }
                                                </div>
                                                <div>LSA Only Policies</div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <FileText size={14}/> FIXED
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {
                                                        this.state.reportPolicyReports.benefitTypeTotals
                                                            .totalFixed
                                                    }
                                                </div>
                                                <div>Fixed HSA/LSA Policies</div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <FileText size={14}/> FLEX
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {
                                                        this.state.reportPolicyReports.benefitTypeTotals
                                                            .totalFlex
                                                    }
                                                </div>
                                                <div>Flex HSA/LSA Policies</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <div className="row">
                                            <div className="col col-4">{provinceTable}</div>
                                            <div className="col col-8">{provincePie}</div>
                                        </div>
                                    </div>

                                    {contestCodeTable && (
                                        <div className="mt-4">
                                            <div className="mb-2 dashboard-summary-header">Contest Codes</div>
                                            <div className="row">
                                                <div className="col col-8">{contestCodeTable}</div>
                                            </div>
                                            {contestAdvisorTable && (
                                                <div className="mt-4">
                                                    <div className="mb-2 dashboard-summary-header">Top Advisors by Contest Codes</div>
                                                    <div className="row">
                                                        <div className="col col-8">{contestAdvisorTable}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {contestMonthlyTable && (
                                                <div className="mt-4">
                                                    <div className="mb-2 dashboard-summary-header">Contest Enrollments by Month</div>
                                                    <div className="row">
                                                        <div className="col col-4">{contestMonthlyTable}</div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    <div className="mt-4">
                                        <ResponsiveContainer width="100%" height={400}>
                                            <BarChart
                                                data={distributionData}
                                                margin={{
                                                    top: 20,
                                                    right: 30,
                                                    left: 20,
                                                    bottom: 5,
                                                }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3"/>
                                                <XAxis dataKey="name"/>
                                                <YAxis/>
                                                <Tooltip/>
                                                <Bar dataKey="Companies" fill="#059454"/>
                                            </BarChart>
                                        </ResponsiveContainer>
                                        <div className="text-center">Employee Distribution</div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                );
            } else if (this.state.currentTab == "advisors") {
                const formatDate = (date) => {
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}_${month}_${day}`;
                };
                const fileName = `JG_ADVISOR_${formatDate(this.state.advisorFromDate)}_to_${formatDate(this.state.advisorToDate)}.csv`;

                // Build CSV data in the same order as table columns, using the sorted list
                const csvData = this.getGroupedByDistroList()?.map(item => {
                    const orderedItem: any = {};
                    if (!this.state.groupByDistro) {
                        orderedItem.advisorId = item.advisorId;
                        orderedItem.a1Number = item.a1Number;
                    }
                    orderedItem.distroName = item.distroName;
                    if (!this.state.groupByDistro) {
                        orderedItem.advisorName = item.advisorName;
                    }
                    orderedItem.activePolicies = item.activePolicies ?? 0;
                    orderedItem.policiesAdded = item.policiesAdded ?? 0;
                    if (!this.state.groupByDistro) {
                        orderedItem.lastPolicyEnrollment = item.lastPolicyEnrollment
                            ? new Date(item.lastPolicyEnrollment).toISOString().split('T')[0]
                            : '';
                    }
                    orderedItem.totalClaimsPaid = item.totalClaimsPaid ?? 0;
                    orderedItem.newPolicyClaimsPaid = item.newPolicyClaimsPaid ?? 0;
                    orderedItem.advisorCommission = item.advisorCommission ?? 0;
                    if (!this.state.groupByDistro) {
                        orderedItem.rmd = item.rmd;
                        orderedItem.rmdCommission = item.rmdCommission ?? 0;
                        if (this.state.showAdvisorYtd) {
                            orderedItem.rmdCommissionYtd = item.rmdCommissionYtd ?? 0;
                        }
                        orderedItem.bdd1 = item.bdd1;
                        orderedItem.bdd1Commission = item.bdd1Commission ?? 0;
                        if (this.state.showAdvisorYtd) {
                            orderedItem.bdd1CommissionYtd = item.bdd1CommissionYtd ?? 0;
                        }
                        orderedItem.bdd2 = item.bdd2;
                        orderedItem.bdd2Commission = item.bdd2Commission ?? 0;
                        if (this.state.showAdvisorYtd) {
                            orderedItem.bdd2CommissionYtd = item.bdd2CommissionYtd ?? 0;
                        }
                    }
                    orderedItem.distroProvince = item.distroProvince;
                    if (!this.state.groupByDistro) {
                        orderedItem.advisorProvince = item.advisorProvince;
                    }
                    return orderedItem;
                }) || [];

                let advisorList = null;
                if (
                    this.state.reportAdvisors != null &&
                    this.state.reportAdvisors.advisorPolicyCount.length > 0
                ) {
                    advisorList = (
                        <>
                            <div className="dashboard-toolbar">
                                <CustomDateRangePicker
                                    fromDate={this.state.advisorFromDate}
                                    toDate={this.state.advisorToDate}
                                    setFromDate={this.setAdvisorFromDate}
                                    setToDate={this.setAdvisorToDate}
                                />

                                <div className="d-flex align-items-center gap-2">
                                    <label className="mb-0">Advisor Type:</label>
                                    <select
                                        className="form-select"
                                        style={{width: 'auto'}}
                                        value={this.state.advisorTypeFilter}
                                        onChange={(e) => this.setState({advisorTypeFilter: e.target.value})}
                                    >
                                        <option value="jgOnly">JG Advisors Only</option>
                                        <option value="all">All Advisors</option>
                                    </select>
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                    <label className="mb-0">Distro:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{width: '200px'}}
                                        placeholder="Search distro..."
                                        value={this.state.distroSearchFilter}
                                        onChange={(e) => this.setState({
                                            distroSearchFilter: e.target.value,
                                            currentPageAdvisorPolicy: 1
                                        })}
                                    />
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                    <label className="mb-0">Group by Distro</label>
                                    <label className="switch mb-0">
                                        <input type="checkbox" name="groupByDistro"
                                               onChange={(e) => this.setState({
                                                   groupByDistro: e.target.checked,
                                                   currentPageAdvisorPolicy: 1
                                               })}
                                               checked={this.state.groupByDistro}/>
                                        <span className="slider round"></span>
                                    </label>
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                    <label className="mb-0">
                                        Show YTD
                                        <CustomToolTip
                                            header="Show YTD"
                                            bodyContent="Year-To-Date: Commissions from January 1st to today"
                                        />
                                    </label>
                                    <label className="switch mb-0">
                                        <input type="checkbox" name="showAdvisorYtd"
                                               onChange={(e) => this.setState({showAdvisorYtd: e.target.checked})}
                                               checked={this.state.showAdvisorYtd}/>
                                        <span className="slider round"></span>
                                    </label>
                                </div>

                                <div className="d-flex align-items-center gap-2 ms-auto">
                                    <Button variant="primary" onClick={() => this.initializeAdvisorReports()}>
                                        Generate Report
                                    </Button>

                                    {csvData.length > 0 && (
                                        <CSVLink data={csvData} filename={fileName} style={{textDecoration: 'none'}}>
                                            <Button variant="outline-primary">
                                                Export to CSV
                                            </Button>
                                        </CSVLink>
                                    )}
                                </div>
                            </div>
                            <div className="dashboard-table-container">
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover">
                                        <thead>
                                        <tr>
                                            {!this.state.groupByDistro && <th style={{cursor: 'pointer'}} onClick={() => this.handleSort('advisorId')}>
                                                Agent ID {this.state.sortColumn === 'advisorId' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            {!this.state.groupByDistro && <th style={{cursor: 'pointer'}} onClick={() => this.handleSort('a1Number')}>
                                                A1 No. {this.state.sortColumn === 'a1Number' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            <th style={{cursor: 'pointer'}} onClick={() => this.handleSort('distroName')}>
                                                Distro Account {this.state.sortColumn === 'distroName' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            {!this.state.groupByDistro && <th style={{cursor: 'pointer'}} onClick={() => this.handleSort('advisorName')}>
                                                Advisor Name {this.state.sortColumn === 'advisorName' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            <th className={"text-end"} style={{cursor: 'pointer'}} onClick={() => this.handleSort('activePolicies')}>
                                                Active Policies {this.state.sortColumn === 'activePolicies' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            <th className={"text-end"} style={{cursor: 'pointer'}} onClick={() => this.handleSort('policiesAdded')}>
                                                Enrollment Volume <CustomToolTip header="Enrollment Volume" bodyContent="Policies created in this period (by creation date) attributed to this advisor, including cancelled and not-yet-activated policies." /> {this.state.sortColumn === 'policiesAdded' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            {!this.state.groupByDistro && <th style={{cursor: 'pointer'}} onClick={() => this.handleSort('lastPolicyEnrollment')}>
                                                Last Policy Enrollment {this.state.sortColumn === 'lastPolicyEnrollment' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            <th className={"text-end"} style={{cursor: 'pointer'}} onClick={() => this.handleSort('totalClaimsPaid')}>
                                                Total Claims Paid {this.state.sortColumn === 'totalClaimsPaid' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            <th className={"text-end"} style={{cursor: 'pointer'}} onClick={() => this.handleSort('newPolicyClaimsPaid')}>
                                                New Policy Claims
                                                <CustomToolTip
                                                    header="New Policy Claims"
                                                    bodyContent="Total paid claims from policies enrolled May 1, 2025 onwards, with claim disbursements within the selected date range"
                                                />
                                                {this.state.sortColumn === 'newPolicyClaimsPaid' ? (this.state.sortDirection === 'asc' ? ' ↑' : ' ↓') : ''}
                                            </th>
                                            <th className={"text-end"} style={{cursor: 'pointer'}} onClick={() => this.handleSort('advisorCommission')}>
                                                Advisor Comm. {this.state.sortColumn === 'advisorCommission' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            {!this.state.groupByDistro && <th style={{cursor: 'pointer'}} onClick={() => this.handleSort('rmd')}>
                                                RMD {this.state.sortColumn === 'rmd' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            {!this.state.groupByDistro && <th className={"text-end"} style={{cursor: 'pointer'}} onClick={() => this.handleSort('rmdCommission')}>
                                                RMD Comm. {this.state.sortColumn === 'rmdCommission' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            {!this.state.groupByDistro && this.state.showAdvisorYtd && <th className={"text-end"} style={{cursor: 'pointer'}} onClick={() => this.handleSort('rmdCommissionYtd')}>
                                                RMD Comm. YTD {this.state.sortColumn === 'rmdCommissionYtd' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            {!this.state.groupByDistro && <th style={{cursor: 'pointer'}} onClick={() => this.handleSort('bdd1')}>
                                                BDD1 {this.state.sortColumn === 'bdd1' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            {!this.state.groupByDistro && <th className={"text-end"} style={{cursor: 'pointer'}} onClick={() => this.handleSort('bdd1Commission')}>
                                                BDD1 Comm. {this.state.sortColumn === 'bdd1Commission' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            {!this.state.groupByDistro && this.state.showAdvisorYtd && <th className={"text-end"} style={{cursor: 'pointer'}} onClick={() => this.handleSort('bdd1CommissionYtd')}>
                                                BDD1 Comm. YTD {this.state.sortColumn === 'bdd1CommissionYtd' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            {!this.state.groupByDistro && <th style={{cursor: 'pointer'}} onClick={() => this.handleSort('bdd2')}>
                                                BDD2 {this.state.sortColumn === 'bdd2' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            {!this.state.groupByDistro && <th className={"text-end"} style={{cursor: 'pointer'}} onClick={() => this.handleSort('bdd2Commission')}>
                                                BDD2 Comm. {this.state.sortColumn === 'bdd2Commission' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            {!this.state.groupByDistro && this.state.showAdvisorYtd && <th className={"text-end"} style={{cursor: 'pointer'}} onClick={() => this.handleSort('bdd2CommissionYtd')}>
                                                BDD2 Comm. YTD {this.state.sortColumn === 'bdd2CommissionYtd' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                            <th style={{cursor: 'pointer'}} onClick={() => this.handleSort('distroProvince')}>
                                                Distro Province {this.state.sortColumn === 'distroProvince' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            {!this.state.groupByDistro && <th style={{cursor: 'pointer'}} onClick={() => this.handleSort('advisorProvince')}>
                                                Advisor Province {this.state.sortColumn === 'advisorProvince' ? (this.state.sortDirection === 'asc' ? '↑' : '↓') : ''}
                                            </th>}
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.currentAdvisorPolicyRecords().map(
                                            (data, index) => {
                                                return (
                                                    <tr key={index}>
                                                        {!this.state.groupByDistro && <td>{data.advisorId}</td>}
                                                        {!this.state.groupByDistro && <td>{data.a1Number}</td>}
                                                        <td>{data.distroName}</td>
                                                        {!this.state.groupByDistro && <td>{data.advisorName}</td>}
                                                        <td className={"text-end"}>{data.activePolicies}</td>
                                                        <td className={"text-end"}>{data.policiesAdded}</td>
                                                        {!this.state.groupByDistro && <td>{data.lastPolicyEnrollment ? new Date(data.lastPolicyEnrollment).toISOString().split('T')[0] : ''}</td>}
                                                        <td className={"text-end"}>{data.totalClaimsPaid?.toFixed(2) || '0.00'}</td>
                                                        <td className={"text-end"}>{data.newPolicyClaimsPaid?.toFixed(2) || '0.00'}</td>
                                                        <td className={"text-end"}>{(data.advisorCommission ?? 0).toFixed(2)}</td>
                                                        {!this.state.groupByDistro && <td>{data.rmd}</td>}
                                                        {!this.state.groupByDistro && <td className={"text-end"}>{data.rmdCommission ?? 0}</td>}
                                                        {!this.state.groupByDistro && this.state.showAdvisorYtd && <td className={"text-end"}>{data.rmdCommissionYtd ?? 0}</td>}
                                                        {!this.state.groupByDistro && <td>{data.bdd1}</td>}
                                                        {!this.state.groupByDistro && <td className={"text-end"}>{data.bdd1Commission ?? 0}</td>}
                                                        {!this.state.groupByDistro && this.state.showAdvisorYtd && <td className={"text-end"}>{data.bdd1CommissionYtd ?? 0}</td>}
                                                        {!this.state.groupByDistro && <td>{data.bdd2}</td>}
                                                        {!this.state.groupByDistro && <td className={"text-end"}>{data.bdd2Commission ?? 0}</td>}
                                                        {!this.state.groupByDistro && this.state.showAdvisorYtd && <td className={"text-end"}>{data.bdd2CommissionYtd ?? 0}</td>}
                                                        <td>{data.distroProvince}</td>
                                                        {!this.state.groupByDistro && <td>{data.advisorProvince}</td>}
                                                    </tr>
                                                );
                                            }
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="pagination-container" style={{float: 'inline-end'}}>
                                <div className="pagination-info">
                                    <span>Showing {this.state.currentPageAdvisorPolicy * this.state.advisorPolicyItemsPerPage - this.state.advisorPolicyItemsPerPage + 1} - {Math.min(this.state.currentPageAdvisorPolicy * this.state.advisorPolicyItemsPerPage, this.getGroupedByDistroList().length)} entries out of {this.getGroupedByDistroList().length} entries</span>
                                </div>
                                <CustomPagination
                                    nPages={this.nPages(this.getGroupedByDistroList().length, this.state.advisorPolicyItemsPerPage)}
                                    currentPage={this.state.currentPageAdvisorPolicy}
                                    setCurrentPage={this.setAdvisorPolicyCurrentPage}
                                />
                            </div>
                        </>
                    );
                }

                currentContents = (
                    <div className="card-body">
                        <div className="db-claims">
                            {this.state.loadingAdvisorReports ? (
                                <Spinner animation="border"/>
                            ) : (
                                <>
                                    <div className="mb-2 d-flex justify-content-between">
                                        <div className="dashboard-summary-header">
                                            Johnston Group Advisor Summary
                                        </div>
                                    </div>
                                    <div className="row mt-4">{advisorList}</div>
                                </>
                            )}
                        </div>
                    </div>
                );
            } else if (this.state.currentTab === "commissions") {
                // "Sales Commissions" tab — admin-visible. Shows aggregate + trailing revenue (admin fee) report.
                // (the "salesReports" branch below is the Sales-role view, not this one)
                const filteredReactivation = this.getFilteredReactivationList();
                const reactivationCsvData = filteredReactivation.map(item => ({
                    "Agent ID": item.advisorId,
                    "Advisor Name": item.advisorName,
                    "Distro Account": item.distroName,
                    "Advisor Province": item.province,
                    "Advisor Enrollment Date": item.advisorCreatedAt
                        ? new Date(item.advisorCreatedAt).toISOString().split('T')[0]
                        : '',
                    "First Policy Enrollment": item.firstEnrollment
                        ? new Date(item.firstEnrollment).toISOString().split('T')[0]
                        : '',
                    "Most Recent Enrollment": item.mostRecentEnrollment
                        ? new Date(item.mostRecentEnrollment).toISOString().split('T')[0]
                        : '',
                    "Months Since Last Enrollment": item.monthsSinceLastEnrollment != null
                        ? item.monthsSinceLastEnrollment
                        : 'Never',
                    "Enrollments (24 mo)": item.enrollments24,
                    "Enrollments (25+ mo)": item.enrollments25Plus,
                    "Status": item.status,
                }));

                const adminFeeCsvData = this.state.adminFeeData.map(item => ({
                    "Trans Date": item.transDate,
                    "Enroll Date": item.createdAt,
                    "Policy": item.name,
                    "Policy Province": item.taxJurisdictionId,
                    "Claim No.": item.claimNo,
                    "Total Approved": item.totalApproved,
                    "Policy Active Months": item.policyActiveMonths,
                    "Recipient": item.recipientType,
                    "Amount": item.transAmount,
                }));

                const salesAggregateCsvData = this.state.salesAggregateData.map((row) => ({
                    "Region": SALES_AGGREGATE_REGION_LABELS[row.region] || row.region,
                    "Trailing Revenue": `$${Number(row.trailingRevenue || 0).toFixed(2)}`,
                    "Reactivations": row.reactivations || 0,
                    "Reactivations Total": `$${Number(row.reactivationsTotal || 0).toFixed(2)}`,
                    "New Advisor +1st": row.newAdvisor || 0,
                    "New Advisor Total": `$${Number(row.newAdvisorTotal || 0).toFixed(2)}`,
                    "Enrollment Volume": row.enrollmentVolume || 0,
                    "Enrollment Vol Total": `$${Number(row.enrollmentVolTotal || 0).toFixed(2)}`,
                    "Grand Total": `$${Number(row.grandTotal || 0).toFixed(2)}`,
                }));
                const salesAggregateCsvFilename = `Aggregate_Report_${this.state.salesAggregateFilterYear}_${String(this.state.salesAggregateFilterMonth).padStart(2, '0')}.csv`;

                currentContents = (
                    <div className="card-body">
                        <div className="db-claims">
                            <div className="dashboard-toolbar" style={{ marginBottom: '1rem' }}>
                                <div className="dashboard-summary-header">
                                    Sales Aggregate Report
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <label className="mb-0">Month:</label>
                                    <select
                                        className="form-select"
                                        style={{ width: 'auto' }}
                                        value={this.state.salesAggregateFilterMonth}
                                        onChange={(e) => this.setState({ salesAggregateFilterMonth: parseInt(e.target.value) })}
                                    >
                                        {Array.from({ length: 12 }, (_, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {new Date(2000, i).toLocaleString('default', { month: 'long' })}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <label className="mb-0">Year:</label>
                                    <select
                                        className="form-select"
                                        style={{ width: 'auto' }}
                                        value={this.state.salesAggregateFilterYear}
                                        onChange={(e) => this.setState({ salesAggregateFilterYear: parseInt(e.target.value) })}
                                    >
                                        {Array.from({ length: new Date().getFullYear() - 2020 + 1 }, (_, i) => (
                                            <option key={new Date().getFullYear() - i} value={new Date().getFullYear() - i}>
                                                {new Date().getFullYear() - i}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <Button variant="primary" size="sm" onClick={() => this.initializeSalesAggregate()}>
                                        Submit
                                    </Button>
                                </div>
                                <div className="d-flex align-items-center gap-2 ms-auto">
                                    {salesAggregateCsvData.length > 0 && (
                                        <CSVLink data={salesAggregateCsvData} filename={salesAggregateCsvFilename} style={{ textDecoration: 'none' }}>
                                            <Button variant="outline-primary">
                                                Export to CSV
                                            </Button>
                                        </CSVLink>
                                    )}
                                </div>
                            </div>
                            {this.state.loadingSalesAggregate ? (
                                <Spinner animation="border" />
                            ) : this.state.salesAggregateError ? (
                                <div className="alert alert-danger">{this.state.salesAggregateError}</div>
                            ) : (
                                <div className="dashboard-table-container" style={{ marginBottom: '2rem' }}>
                                    <div className="table-responsive">
                                        <table className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Region</th>
                                                    <th className="text-end">Trailing Revenue</th>
                                                    <th className="text-end">Reactivations</th>
                                                    <th className="text-end">Reactivations Total</th>
                                                    <th className="text-end">New Advisor +1st</th>
                                                    <th className="text-end">New Advisor Total</th>
                                                    <th className="text-end">Enrollment Volume <CustomToolTip header="Enrollment Volume" bodyContent="Policies created in this period (by creation date), including cancelled and not-yet-activated policies. A policy assigned to one region counts 1; a policy assigned to two regions counts 0.5 to each." /></th>
                                                    <th className="text-end">Enrollment Vol Total</th>
                                                    <th className="text-end">Grand Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.salesAggregateData.map((row) => (
                                                    <tr key={row.region}>
                                                        <td>{SALES_AGGREGATE_REGION_LABELS[row.region] || row.region}</td>
                                                        <td className="text-end">${Number(row.trailingRevenue || 0).toFixed(2)}</td>
                                                        <td className="text-end">{row.reactivations || 0}</td>
                                                        <td className="text-end">${Number(row.reactivationsTotal || 0).toFixed(2)}</td>
                                                        <td className="text-end">{row.newAdvisor || 0}</td>
                                                        <td className="text-end">${Number(row.newAdvisorTotal || 0).toFixed(2)}</td>
                                                        <td className="text-end">{row.enrollmentVolume || 0}</td>
                                                        <td className="text-end">${Number(row.enrollmentVolTotal || 0).toFixed(2)}</td>
                                                        <td className="text-end">${Number(row.grandTotal || 0).toFixed(2)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                            {this.state.loadingAdminFee ? (
                                <Spinner animation="border" />
                            ) : (
                                <>
                                    <div className="dashboard-toolbar">
                                        <div className="dashboard-summary-header">
                                            Trailing Revenue (Admin Fee Report)
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <label className="mb-0">Month:</label>
                                            <select
                                                className="form-select"
                                                style={{ width: 'auto' }}
                                                value={this.state.adminFeeFilterMonth}
                                                onChange={(e) => this.setState({ adminFeeFilterMonth: parseInt(e.target.value) })}
                                            >
                                                {Array.from({ length: 12 }, (_, i) => (
                                                    <option key={i + 1} value={i + 1}>
                                                        {new Date(0, i).toLocaleString("default", { month: "long" })}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <label className="mb-0">Year:</label>
                                            <select
                                                className="form-select"
                                                style={{ width: 'auto' }}
                                                value={this.state.adminFeeFilterYear}
                                                onChange={(e) => this.setState({ adminFeeFilterYear: parseInt(e.target.value) })}
                                            >
                                                {Array.from({ length: new Date().getFullYear() - 2020 + 1 }, (_, i) => (
                                                    <option key={new Date().getFullYear() - i} value={new Date().getFullYear() - i}>
                                                        {new Date().getFullYear() - i}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <label className="mb-0">Recipient:</label>
                                            <select
                                                className="form-select"
                                                style={{ width: 'auto' }}
                                                value={this.state.adminFeeFilterRecipient}
                                                onChange={(e) => this.setState({ adminFeeFilterRecipient: e.target.value })}
                                            >
                                                <option value="ALL">Show All</option>
                                                <option value="NHC">Show NHC</option>
                                                <option value="SALES">Show Sales</option>
                                                <option value="REG1">Show Region 1</option>
                                                <option value="REG2">Show Region 2</option>
                                                <option value="REG3">Show Region 3</option>
                                            </select>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <Button variant="primary" size="sm" onClick={() => this.initializeAdminFee()}>
                                                Submit
                                            </Button>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 ms-auto">
                                            {adminFeeCsvData.length > 0 && (
                                                <CSVLink data={adminFeeCsvData} filename={`adminfees_${new Date().toISOString().slice(0, 10)}.csv`} style={{ textDecoration: 'none' }}>
                                                    <Button variant="outline-primary">
                                                        Export to CSV
                                                    </Button>
                                                </CSVLink>
                                            )}
                                            <Button
                                                variant="outline-secondary"
                                                onClick={this.exportAdminFeeAllRegions}
                                                disabled={this.state.exportingAdminFeeZip}
                                            >
                                                {this.state.exportingAdminFeeZip ? (
                                                    <><Spinner animation="border" size="sm" className="me-1" /> Exporting...</>
                                                ) : (
                                                    "Export All Regions"
                                                )}
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="dashboard-table-container">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-hover">
                                                <thead>
                                                    <tr>
                                                        <th style={{ cursor: 'pointer', minWidth: 100 }} onClick={() => this.handleAdminFeeSort('transDate')}>
                                                            Trans Date {this.state.adminFeeSortColumn === 'transDate' ? (this.state.adminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer', minWidth: 100 }} onClick={() => this.handleAdminFeeSort('createdAt')}>
                                                            Enroll Date {this.state.adminFeeSortColumn === 'createdAt' ? (this.state.adminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleAdminFeeSort('name')}>
                                                            Policy {this.state.adminFeeSortColumn === 'name' ? (this.state.adminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleAdminFeeSort('taxJurisdictionId')}>
                                                            Policy Province {this.state.adminFeeSortColumn === 'taxJurisdictionId' ? (this.state.adminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleAdminFeeSort('claimNo')}>
                                                            Claim No. {this.state.adminFeeSortColumn === 'claimNo' ? (this.state.adminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleAdminFeeSort('totalApproved')}>
                                                            Total Approved {this.state.adminFeeSortColumn === 'totalApproved' ? (this.state.adminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleAdminFeeSort('policyActiveMonths')}>
                                                            Policy Active Months {this.state.adminFeeSortColumn === 'policyActiveMonths' ? (this.state.adminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleAdminFeeSort('recipientType')}>
                                                            Recipient {this.state.adminFeeSortColumn === 'recipientType' ? (this.state.adminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleAdminFeeSort('transAmount')}>
                                                            Amount {this.state.adminFeeSortColumn === 'transAmount' ? (this.state.adminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.currentAdminFeeRecords().map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.transDate}</td>
                                                            <td>{data.createdAt}</td>
                                                            <td>{data.name}</td>
                                                            <td>{data.taxJurisdictionId}</td>
                                                            <td>{data.claimNo}</td>
                                                            <td className="text-end">{data.totalApproved?.toFixed(2)}</td>
                                                            <td className="text-end">{data.policyActiveMonths}</td>
                                                            <td>{data.recipientType}</td>
                                                            <td className="text-end">{data.transAmount?.toFixed(2)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', fontWeight: 500, fontSize: 16, flexWrap: 'wrap', gap: 16, padding: '0 0 16px' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                            <div>
                                                Total Revenue:{' '}
                                                {this.state.adminFeeTotalCombined.toLocaleString(undefined, { style: 'currency', currency: 'USD' })}
                                            </div>
                                            <div>
                                                Total NHC Revenue:{' '}
                                                {this.state.adminFeeTotalNHC.toLocaleString(undefined, { style: 'currency', currency: 'USD' })}
                                            </div>
                                            <div>
                                                Total Sales Revenue:{' '}
                                                {this.state.adminFeeTotalSales.toLocaleString(undefined, { style: 'currency', currency: 'USD' })}
                                            </div>
                                        </div>
                                        <div className="pagination-container" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                                            <div className="pagination-info">
                                                <span>Showing {this.state.adminFeeData.length > 0 ? (this.state.currentPageAdminFee - 1) * this.state.adminFeeItemsPerPage + 1 : 0} - {Math.min(this.state.currentPageAdminFee * this.state.adminFeeItemsPerPage, this.state.adminFeeData.length)} entries out of {this.state.adminFeeData.length} entries</span>
                                            </div>
                                            <CustomPagination
                                                nPages={this.nPages(this.state.adminFeeData.length, this.state.adminFeeItemsPerPage)}
                                                currentPage={this.state.currentPageAdminFee}
                                                setCurrentPage={this.setAdminFeeCurrentPage}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                            <hr style={{ margin: '24px 0' }} />

                            {this.state.loadingActivityReport ? (
                                <Spinner animation="border" />
                            ) : (
                                <>
                                    <div className="dashboard-toolbar">
                                        <div className="dashboard-summary-header">
                                            Activity Report
                                        </div>
                                        {this.renderActivityReportFilters()}
                                        <div className="d-flex align-items-center gap-2 ms-auto">
                                            <CSVLink
                                                data={[{
                                                    "": "Reactivation - No New Enrollment in the last 24m",
                                                    "Rate": "$137.50",
                                                    "Region 1 (BC, SK, MB)": this.state.reactivationReg1,
                                                    "Region 1 Total": (this.state.reactivationReg1 * 137.5).toFixed(2),
                                                    "Region 2 (AB, NB, NS, PE, NL)": this.state.reactivationReg2,
                                                    "Region 2 Total": (this.state.reactivationReg2 * 137.5).toFixed(2),
                                                    "Region 3 (ON)": this.state.reactivationReg3,
                                                    "Region 3 Total": (this.state.reactivationReg3 * 137.5).toFixed(2),
                                                    "No Region": this.state.reactivationNoReg,
                                                    "No Region Total": (this.state.reactivationNoReg * 137.5).toFixed(2),
                                                }, {
                                                    "": "Reactivation - No Prior Enrollment",
                                                    "Rate": "$137.50",
                                                    "Region 1 (BC, SK, MB)": this.state.noPriorReg1,
                                                    "Region 1 Total": (this.state.noPriorReg1 * 137.5).toFixed(2),
                                                    "Region 2 (AB, NB, NS, PE, NL)": this.state.noPriorReg2,
                                                    "Region 2 Total": (this.state.noPriorReg2 * 137.5).toFixed(2),
                                                    "Region 3 (ON)": this.state.noPriorReg3,
                                                    "Region 3 Total": (this.state.noPriorReg3 * 137.5).toFixed(2),
                                                    "No Region": this.state.noPriorNoReg,
                                                    "No Region Total": (this.state.noPriorNoReg * 137.5).toFixed(2),
                                                }, {
                                                    "": "New Advisor (First Policy)",
                                                    "Rate": "$412.50",
                                                    "Region 1 (BC, SK, MB)": this.state.newAdvisorReg1,
                                                    "Region 1 Total": (this.state.newAdvisorReg1 * 412.5).toFixed(2),
                                                    "Region 2 (AB, NB, NS, PE, NL)": this.state.newAdvisorReg2,
                                                    "Region 2 Total": (this.state.newAdvisorReg2 * 412.5).toFixed(2),
                                                    "Region 3 (ON)": this.state.newAdvisorReg3,
                                                    "Region 3 Total": (this.state.newAdvisorReg3 * 412.5).toFixed(2),
                                                    "No Region": this.state.newAdvisorNoReg,
                                                    "No Region Total": (this.state.newAdvisorNoReg * 412.5).toFixed(2),
                                                },
                                                {
                                                    "": "Enrollment Volume",
                                                    "Rate": "$12.22",
                                                    "Region 1 (BC, SK, MB)": this.state.policyCreatedReg1,
                                                    "Region 1 Total": (this.state.policyCreatedReg1 * 12.22).toFixed(2),
                                                    "Region 2 (AB, NB, NS, PE, NL)": this.state.policyCreatedReg2,
                                                    "Region 2 Total": (this.state.policyCreatedReg2 * 12.22).toFixed(2),
                                                    "Region 3 (ON)": this.state.policyCreatedReg3,
                                                    "Region 3 Total": (this.state.policyCreatedReg3 * 12.22).toFixed(2),
                                                    "No Region": this.state.policyCreatedNoReg,
                                                    "No Region Total": (this.state.policyCreatedNoReg * 12.22).toFixed(2),
                                                }]}
                                                filename={`activity_report_${this.activityReportPeriodLabel()}.csv`}
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <Button variant="outline-primary">
                                                    Export to CSV
                                                </Button>
                                            </CSVLink>
                                        </div>
                                    </div>
                                    <InfoBox style={{ marginBottom: 12, fontSize: 14 }}>
                                        <strong>New Advisor (First Policy):</strong> in the exported CSV, <strong>EnrollmentDate</strong> is the later of the policy effective date and the created-at date (the created-at date is used when the policy has no effective date).
                                    </InfoBox>
                                    <div className="table-responsive">
                                        <table className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th style={{ textAlign: 'right' }}>Rate</th>
                                                    <th style={{ textAlign: 'right' }}><span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>Region 1 <CustomToolTip header="Region 1" bodyContent="BC, SK, MB" /></span></th>
                                                    <th style={{ textAlign: 'right' }}>Region 1 Total</th>
                                                    <th style={{ textAlign: 'right' }}><span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>Region 2 <CustomToolTip header="Region 2" bodyContent="AB, NB, NS, PE, NL" /></span></th>
                                                    <th style={{ textAlign: 'right' }}>Region 2 Total</th>
                                                    <th style={{ textAlign: 'right' }}><span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>Region 3 <CustomToolTip header="Region 3" bodyContent="ON" /></span></th>
                                                    <th style={{ textAlign: 'right' }}>Region 3 Total</th>
                                                    <th style={{ textAlign: 'right' }}>No Region</th>
                                                    <th style={{ textAlign: 'right' }}>No Region Total</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap' }}>
                                                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Reactivation - No New Enrollment in the last 24m <CustomToolTip header="Reactivation - No New Enrollment in the last 24m" bodyContent="Advisors with a policy created this month, at least one policy created 24+ months ago, and none created in the 24 months between. Based on policy creation date - cancelled policies still count as enrollments." /></span>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>$137.50</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.reactivationReg1}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.reactivationReg1 * 137.5).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.reactivationReg2}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.reactivationReg2 * 137.5).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.reactivationReg3}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.reactivationReg3 * 137.5).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.reactivationNoReg}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.reactivationNoReg * 137.5).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <button className="btn btn-link btn-sm p-0" title="Download detail"
                                                            onClick={() => this.downloadActivityDetail('reactivation', 'advisor_reactivation')}>
                                                            <Download size={14} style={{ opacity: 0.6 }} />
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap' }}>
                                                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Reactivation - No Prior Enrollment <CustomToolTip header="Reactivation - No Prior Enrollment" bodyContent="Advisors registered before Jan 1 2026 whose first-ever policy was created this month. Based on policy creation date - cancelled policies still count." /></span>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>$137.50</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.noPriorReg1}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.noPriorReg1 * 137.5).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.noPriorReg2}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.noPriorReg2 * 137.5).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.noPriorReg3}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.noPriorReg3 * 137.5).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.noPriorNoReg}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.noPriorNoReg * 137.5).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <button className="btn btn-link btn-sm p-0" title="Download detail"
                                                            onClick={() => this.downloadActivityDetail('noPrior', 'reactivation_no_prior')}>
                                                            <Download size={14} style={{ opacity: 0.6 }} />
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap' }}>
                                                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>New Advisor (First Policy) <CustomToolTip header="New Advisor (First Policy)" bodyContent="Starting from January 1 2026" /></span>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>$412.50</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.newAdvisorReg1}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.newAdvisorReg1 * 412.5).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.newAdvisorReg2}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.newAdvisorReg2 * 412.5).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.newAdvisorReg3}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.newAdvisorReg3 * 412.5).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.newAdvisorNoReg}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.newAdvisorNoReg * 412.5).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <button className="btn btn-link btn-sm p-0" title="Download detail"
                                                            onClick={() => this.downloadActivityDetail('newAdvisor', 'new_advisor')}>
                                                            <Download size={14} style={{ opacity: 0.6 }} />
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ whiteSpace: 'nowrap' }}>
                                                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Enrollment Volume <CustomToolTip header="Enrollment Volume" bodyContent="Policies created in this period (by creation date), including cancelled and not-yet-activated policies. A policy assigned to one region counts 1; a policy assigned to two regions counts 0.5 to each." /></span>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>$12.22</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.policyCreatedReg1}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.policyCreatedReg1 * 12.22).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.policyCreatedReg2}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.policyCreatedReg2 * 12.22).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.policyCreatedReg3}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.policyCreatedReg3 * 12.22).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>{this.state.policyCreatedNoReg}</td>
                                                    <td style={{ textAlign: 'right' }}>${(this.state.policyCreatedNoReg * 12.22).toFixed(2)}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <button className="btn btn-link btn-sm p-0" title="Download detail"
                                                            onClick={() => this.downloadActivityDetail('policyCount', 'policy_count')}>
                                                            <Download size={14} style={{ opacity: 0.6 }} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}

                            <hr style={{ margin: '24px 0' }} />

                            {this.state.loadingReactivation ? (
                                <Spinner animation="border" />
                            ) : (
                                <>
                                    <div className="dashboard-toolbar">
                                        <div className="dashboard-summary-header">
                                            Advisor Reactivation
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <label className="mb-0">Status:</label>
                                            <select
                                                className="form-select"
                                                style={{ width: 'auto' }}
                                                value={this.state.reactivationStatusFilter}
                                                onChange={(e) => this.setState({ reactivationStatusFilter: e.target.value, currentPageReactivation: 1 })}
                                            >
                                                <option value="ALL">All</option>
                                                <option value="Active">Active</option>
                                                <option value="Dormant">Dormant</option>
                                            </select>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <label className="mb-0">Months Since Last:</label>
                                            <select
                                                className="form-select"
                                                style={{ width: 'auto' }}
                                                value={this.state.reactivationMonthsFilter}
                                                onChange={(e) => this.setState({ reactivationMonthsFilter: e.target.value, currentPageReactivation: 1 })}
                                            >
                                                <option value="ALL">All</option>
                                                <option value="NEVER">Never</option>
                                                <option value="12">Within 12 Months</option>
                                                <option value="24">Within 24 Months</option>
                                                <option value="25+">25+ Months</option>
                                            </select>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 ms-auto">
                                            {reactivationCsvData.length > 0 && (
                                                <CSVLink data={reactivationCsvData} filename="advisor_reactivation.csv" style={{ textDecoration: 'none' }}>
                                                    <Button variant="outline-primary">
                                                        Export to CSV
                                                    </Button>
                                                </CSVLink>
                                            )}
                                        </div>
                                    </div>
                                    <div className="dashboard-table-container">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-hover">
                                                <thead>
                                                    <tr>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleReactivationSort('advisorId')}>
                                                            Agent ID {this.state.reactivationSortColumn === 'advisorId' ? (this.state.reactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleReactivationSort('advisorName')}>
                                                            Advisor Name {this.state.reactivationSortColumn === 'advisorName' ? (this.state.reactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleReactivationSort('distroName')}>
                                                            Distro Account {this.state.reactivationSortColumn === 'distroName' ? (this.state.reactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleReactivationSort('province')}>
                                                            Advisor Province {this.state.reactivationSortColumn === 'province' ? (this.state.reactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleReactivationSort('advisorCreatedAt')}>
                                                            Advisor Enrollment Date {this.state.reactivationSortColumn === 'advisorCreatedAt' ? (this.state.reactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleReactivationSort('firstEnrollment')}>
                                                            First Policy Enrollment {this.state.reactivationSortColumn === 'firstEnrollment' ? (this.state.reactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleReactivationSort('mostRecentEnrollment')}>
                                                            Most Recent Enrollment {this.state.reactivationSortColumn === 'mostRecentEnrollment' ? (this.state.reactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleReactivationSort('monthsSinceLastEnrollment')}>
                                                            Months Since Last {this.state.reactivationSortColumn === 'monthsSinceLastEnrollment' ? (this.state.reactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleReactivationSort('enrollments24')}>
                                                            Enrollments (24 mo) {this.state.reactivationSortColumn === 'enrollments24' ? (this.state.reactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleReactivationSort('enrollments25Plus')}>
                                                            Enrollments (25+ mo) {this.state.reactivationSortColumn === 'enrollments25Plus' ? (this.state.reactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleReactivationSort('status')}>
                                                            Status {this.state.reactivationSortColumn === 'status' ? (this.state.reactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.currentReactivationRecords().map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.advisorId}</td>
                                                            <td>{data.advisorName}</td>
                                                            <td>{data.distroName}</td>
                                                            <td>{data.province}</td>
                                                            <td>{data.advisorCreatedAt ? new Date(data.advisorCreatedAt).toISOString().split('T')[0] : ''}</td>
                                                            <td>{data.firstEnrollment ? new Date(data.firstEnrollment).toISOString().split('T')[0] : ''}</td>
                                                            <td>{data.mostRecentEnrollment ? new Date(data.mostRecentEnrollment).toISOString().split('T')[0] : ''}</td>
                                                            <td className="text-end">{data.monthsSinceLastEnrollment != null ? data.monthsSinceLastEnrollment : 'Never'}</td>
                                                            <td className="text-end">{data.enrollments24}</td>
                                                            <td className="text-end">{data.enrollments25Plus}</td>
                                                            <td>
                                                                <span style={{
                                                                    color: data.status === 'Active' ? '#059454' : '#dc3545',
                                                                    fontWeight: 600,
                                                                }}>
                                                                    {data.status}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="pagination-container" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 12, flexWrap: 'wrap', paddingBottom: 16 }}>
                                        <div className="pagination-info">
                                            <span>Showing {filteredReactivation.length > 0 ? this.state.currentPageReactivation * this.state.reactivationItemsPerPage - this.state.reactivationItemsPerPage + 1 : 0} - {Math.min(this.state.currentPageReactivation * this.state.reactivationItemsPerPage, filteredReactivation.length)} entries out of {filteredReactivation.length} entries</span>
                                        </div>
                                        <CustomPagination
                                            nPages={this.nPages(filteredReactivation.length, this.state.reactivationItemsPerPage)}
                                            currentPage={this.state.currentPageReactivation}
                                            setCurrentPage={this.setReactivationCurrentPage}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                );
            } else if (this.state.currentTab === "financials") {
                currentContents = null;
            } else if (this.state.currentTab === "leadership") {
                currentContents = null;
            } else if (this.state.currentTab === "salesReports") {
                // "Sales Reports" tab — Sales-role view, scoped to their own region.
                // (admin "Sales Commissions" tab is the "commissions" branch above)
                const salesCsvData = this.state.salesReportData.map(item => ({
                    "Trans Date": item.transDate,
                    "Enroll Date": item.createdAt,
                    "Policy": item.name,
                    "Policy Province": item.taxJurisdictionId,
                    "Claim No.": item.claimNo,
                    "Total Approved": item.totalApproved,
                    "Policy Active Months": item.policyActiveMonths,
                    "Recipient": item.recipientType,
                    "Amount": item.transAmount,
                }));

                currentContents = (
                    <div className="card-body">
                        <div className="db-claims">
                            {this.state.loadingSalesReport ? (
                                <Spinner animation="border" />
                            ) : (
                                <>
                                    <div className="dashboard-toolbar">
                                        <div className="dashboard-summary-header">
                                            Sales Report
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <label className="mb-0">Month:</label>
                                            <select
                                                className="form-select"
                                                style={{ width: 'auto' }}
                                                value={this.state.salesReportFilterMonth}
                                                onChange={(e) => this.setState({ salesReportFilterMonth: parseInt(e.target.value) })}
                                            >
                                                {Array.from({ length: 12 }, (_, i) => (
                                                    <option key={i + 1} value={i + 1}>
                                                        {new Date(2000, i).toLocaleString('default', { month: 'long' })}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <label className="mb-0">Year:</label>
                                            <select
                                                className="form-select"
                                                style={{ width: 'auto' }}
                                                value={this.state.salesReportFilterYear}
                                                onChange={(e) => this.setState({ salesReportFilterYear: parseInt(e.target.value) })}
                                            >
                                                {Array.from({ length: new Date().getFullYear() - 2020 + 1 }, (_, i) => (
                                                    <option key={new Date().getFullYear() - i} value={new Date().getFullYear() - i}>
                                                        {new Date().getFullYear() - i}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <Button variant="primary" size="sm" onClick={() => this.initializeSalesReport()}>
                                                Submit
                                            </Button>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 ms-auto">
                                            {salesCsvData.length > 0 && (
                                                <CSVLink data={salesCsvData} filename={`sales_report_${this.state.salesRegion}_${new Date().toISOString().slice(0, 10)}.csv`} style={{ textDecoration: 'none' }}>
                                                    <Button variant="outline-primary">
                                                        Export to CSV
                                                    </Button>
                                                </CSVLink>
                                            )}
                                        </div>
                                    </div>
                                    <div className="dashboard-table-container">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-hover">
                                                <thead>
                                                    <tr>
                                                        <th style={{ cursor: 'pointer', minWidth: 100 }} onClick={() => this.handleSalesReportSort('transDate')}>
                                                            Trans Date {this.state.salesReportSortColumn === 'transDate' ? (this.state.salesReportSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer', minWidth: 100 }} onClick={() => this.handleSalesReportSort('createdAt')}>
                                                            Enroll Date {this.state.salesReportSortColumn === 'createdAt' ? (this.state.salesReportSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReportSort('name')}>
                                                            Policy {this.state.salesReportSortColumn === 'name' ? (this.state.salesReportSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReportSort('taxJurisdictionId')}>
                                                            Province {this.state.salesReportSortColumn === 'taxJurisdictionId' ? (this.state.salesReportSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReportSort('claimNo')}>
                                                            Claim No. {this.state.salesReportSortColumn === 'claimNo' ? (this.state.salesReportSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReportSort('totalApproved')}>
                                                            Total Approved {this.state.salesReportSortColumn === 'totalApproved' ? (this.state.salesReportSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReportSort('policyActiveMonths')}>
                                                            Policy Active Months {this.state.salesReportSortColumn === 'policyActiveMonths' ? (this.state.salesReportSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReportSort('recipientType')}>
                                                            Recipient {this.state.salesReportSortColumn === 'recipientType' ? (this.state.salesReportSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                        <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReportSort('transAmount')}>
                                                            Amount {this.state.salesReportSortColumn === 'transAmount' ? (this.state.salesReportSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.currentSalesReportRecords().map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.transDate}</td>
                                                            <td>{data.createdAt}</td>
                                                            <td>{data.name}</td>
                                                            <td>{data.taxJurisdictionId}</td>
                                                            <td>{data.claimNo}</td>
                                                            <td className="text-end">{data.totalApproved?.toFixed(2)}</td>
                                                            <td className="text-end">{data.policyActiveMonths}</td>
                                                            <td>{data.recipientType}</td>
                                                            <td className="text-end">{data.transAmount?.toFixed(2)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', fontWeight: 500, fontSize: 16, flexWrap: 'wrap', gap: 16, padding: '0 0 16px' }}>
                                        <div>
                                            Total Amount:{' '}
                                            {this.state.salesReportTotal.toLocaleString(undefined, { style: 'currency', currency: 'USD' })}
                                        </div>
                                        <div className="pagination-container" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                                            <div className="pagination-info">
                                                <span>Showing {this.state.salesReportData.length > 0 ? (this.state.currentPageSalesReport - 1) * this.state.salesReportItemsPerPage + 1 : 0} - {Math.min(this.state.currentPageSalesReport * this.state.salesReportItemsPerPage, this.state.salesReportData.length)} entries out of {this.state.salesReportData.length} entries</span>
                                            </div>
                                            <CustomPagination
                                                nPages={this.nPages(this.state.salesReportData.length, this.state.salesReportItemsPerPage)}
                                                currentPage={this.state.currentPageSalesReport}
                                                setCurrentPage={this.setSalesReportCurrentPage}
                                            />
                                        </div>
                                    </div>

                                    {/* Policy Admin Fee Report */}
                                    <div className="dashboard-toolbar" style={{ marginTop: 32 }}>
                                        <div className="dashboard-summary-header">
                                            Policy Admin Fee Report
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <CustomDateRangePicker
                                                fromDate={this.state.salesAdminFeeFromDate}
                                                toDate={this.state.salesAdminFeeToDate}
                                                setFromDate={this.setSalesAdminFeeFromDate}
                                                setToDate={this.setSalesAdminFeeToDate}
                                            />
                                        </div>
                                        <div className="d-flex align-items-center gap-2 ms-auto">
                                            {this.state.salesAdminFeeData.length > 0 && (
                                                <CSVLink data={this.state.salesAdminFeeData} filename={`policy_admin_fees_${new Date().toISOString().slice(0, 10)}.csv`} style={{ textDecoration: 'none' }}>
                                                    <Button variant="outline-primary">
                                                        Export to CSV
                                                    </Button>
                                                </CSVLink>
                                            )}
                                        </div>
                                    </div>
                                    {this.state.loadingSalesAdminFee ? (
                                        <div style={{ textAlign: 'center', padding: 24 }}>
                                            <Spinner animation="border" />
                                        </div>
                                    ) : this.state.salesAdminFeeData.length > 0 ? (
                                        <>
                                            <div className="dashboard-table-container">
                                                <div className="table-responsive">
                                                    <table className="table table-striped table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('company')}>
                                                                    Company {this.state.salesAdminFeeSortColumn === 'company' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('policyNo')}>
                                                                    Policy No. {this.state.salesAdminFeeSortColumn === 'policyNo' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('status')}>
                                                                    Status {this.state.salesAdminFeeSortColumn === 'status' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th style={{ cursor: 'pointer', minWidth: 100 }} onClick={() => this.handleSalesAdminFeeSort('enrollDate')}>
                                                                    Enroll Date {this.state.salesAdminFeeSortColumn === 'enrollDate' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th style={{ cursor: 'pointer', minWidth: 100 }} onClick={() => this.handleSalesAdminFeeSort('startDate')}>
                                                                    Start Date {this.state.salesAdminFeeSortColumn === 'startDate' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th style={{ cursor: 'pointer', minWidth: 100 }} onClick={() => this.handleSalesAdminFeeSort('effectiveDate')}>
                                                                    Effective Date {this.state.salesAdminFeeSortColumn === 'effectiveDate' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('advisorId')}>
                                                                    Advisor Id {this.state.salesAdminFeeSortColumn === 'advisorId' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('advisorName')}>
                                                                    Primary Advisor {this.state.salesAdminFeeSortColumn === 'advisorName' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('distroId')}>
                                                                    Distro Id {this.state.salesAdminFeeSortColumn === 'distroId' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('distroName')}>
                                                                    Distro {this.state.salesAdminFeeSortColumn === 'distroName' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('hsaAdminRate')}>
                                                                    HSA Admin Rate {this.state.salesAdminFeeSortColumn === 'hsaAdminRate' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('lsaAdminRate')}>
                                                                    LSA Admin Rate {this.state.salesAdminFeeSortColumn === 'lsaAdminRate' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('nhcCommissionRatio')}>
                                                                    NHC Commission Ratio {this.state.salesAdminFeeSortColumn === 'nhcCommissionRatio' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('advisorCommissionRatio')}>
                                                                    Advisor Commission Ratio {this.state.salesAdminFeeSortColumn === 'advisorCommissionRatio' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('distroCommissionAmount')}>
                                                                    Distro Commission Amount {this.state.salesAdminFeeSortColumn === 'distroCommissionAmount' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleSalesAdminFeeSort('nhcCommissionAmount')}>
                                                                    NHC Commission Amount {this.state.salesAdminFeeSortColumn === 'nhcCommissionAmount' ? (this.state.salesAdminFeeSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.currentSalesAdminFeeRecords().map((data, index) => (
                                                                <tr key={index}>
                                                                    <td>{data.company}</td>
                                                                    <td>{data.policyNo}</td>
                                                                    <td style={{ color: data.status === "Active" ? "green" : "gray" }}>{data.status}</td>
                                                                    <td>{data.enrollDate}</td>
                                                                    <td>{data.startDate}</td>
                                                                    <td>{data.effectiveDate}</td>
                                                                    <td>{data.advisorId}</td>
                                                                    <td>{data.advisorName}</td>
                                                                    <td>{data.distroId}</td>
                                                                    <td>{data.distroName}</td>
                                                                    <td className="text-end">{data.hsaAdminRate}</td>
                                                                    <td className="text-end">{data.lsaAdminRate}</td>
                                                                    <td className="text-end">{data.nhcCommissionRatio}</td>
                                                                    <td className="text-end">{data.advisorCommissionRatio}</td>
                                                                    <td className="text-end">{data.distroCommissionAmount}</td>
                                                                    <td className="text-end">{data.nhcCommissionAmount}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', fontWeight: 500, fontSize: 16, flexWrap: 'wrap', gap: 16, padding: '0 0 16px' }}>
                                                <div>
                                                    <div>Total Claim Commission: ${this.state.salesAdminFeeTotalNhc}</div>
                                                    <div>Total Enroll Fee Commission: ${this.state.salesAdminFeeTotalEnroll}</div>
                                                    <div>Total NHC Revenue: ${this.state.salesAdminFeeTotalEnroll + this.state.salesAdminFeeTotalNhc}</div>
                                                </div>
                                                <div className="pagination-container" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                                                    <div className="pagination-info">
                                                        <span>Showing {(this.state.currentPageSalesAdminFee - 1) * this.state.salesAdminFeeItemsPerPage + 1} - {Math.min(this.state.currentPageSalesAdminFee * this.state.salesAdminFeeItemsPerPage, this.state.salesAdminFeeData.length)} entries out of {this.state.salesAdminFeeData.length} entries</span>
                                                    </div>
                                                    <CustomPagination
                                                        nPages={this.nPages(this.state.salesAdminFeeData.length, this.state.salesAdminFeeItemsPerPage)}
                                                        currentPage={this.state.currentPageSalesAdminFee}
                                                        setCurrentPage={this.setSalesAdminFeeCurrentPage}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ padding: 16, color: '#666' }}>No data available for the selected date range.</div>
                                    )}

                                    {/* Activity Report */}
                                    <hr style={{ margin: '24px 0' }} />
                                    {this.state.loadingActivityReport ? (
                                        <Spinner animation="border" />
                                    ) : (() => {
                                        const regionNameMap = { REG1: "Region 1", REG2: "Region 2", REG3: "Region 3" };
                                        const regionTooltipMap = { REG1: "BC, SK, MB", REG2: "AB, NB, NS, PE, NL", REG3: "ON" };
                                        const regionDisplayName = regionNameMap[this.state.salesRegion] || this.state.salesRegion;
                                        const regionTooltip = regionTooltipMap[this.state.salesRegion] || "";
                                        const regKey = this.state.salesRegion === "REG1" ? "Reg1" : this.state.salesRegion === "REG2" ? "Reg2" : "Reg3";

                                        const reactivationCount = this.state[`reactivation${regKey}`];
                                        const noPriorCount = this.state[`noPrior${regKey}`];
                                        const newAdvisorCount = this.state[`newAdvisor${regKey}`];
                                        const enrollmentVolumeCount = this.state[`policyCreated${regKey}`];

                                        const salesActivityCsvData = [{
                                            "": "Reactivation - No New Enrollment in the last 24m",
                                            "Rate": "$137.50",
                                            [regionDisplayName]: reactivationCount,
                                            [`${regionDisplayName} Total`]: (reactivationCount * 137.5).toFixed(2),
                                        }, {
                                            "": "Reactivation - No Prior Enrollment",
                                            "Rate": "$137.50",
                                            [regionDisplayName]: noPriorCount,
                                            [`${regionDisplayName} Total`]: (noPriorCount * 137.5).toFixed(2),
                                        }, {
                                            "": "New Advisor (First Policy)",
                                            "Rate": "$412.50",
                                            [regionDisplayName]: newAdvisorCount,
                                            [`${regionDisplayName} Total`]: (newAdvisorCount * 412.5).toFixed(2),
                                        }, {
                                            "": "Enrollment Volume",
                                            "Rate": "$12.22",
                                            [regionDisplayName]: enrollmentVolumeCount,
                                            [`${regionDisplayName} Total`]: (enrollmentVolumeCount * 12.22).toFixed(2),
                                        }];

                                        return (
                                            <>
                                                <div className="dashboard-toolbar">
                                                    <div className="dashboard-summary-header">
                                                        Activity Report
                                                    </div>
                                                    {this.renderActivityReportFilters()}
                                                    <div className="d-flex align-items-center gap-2 ms-auto">
                                                        <CSVLink
                                                            data={salesActivityCsvData}
                                                            filename={`activity_report_${regionDisplayName.replace(/\s/g, "_")}_${this.activityReportPeriodLabel()}.csv`}
                                                            style={{ textDecoration: 'none' }}
                                                        >
                                                            <Button variant="outline-primary">
                                                                Export to CSV
                                                            </Button>
                                                        </CSVLink>
                                                    </div>
                                                </div>
                                                <InfoBox style={{ marginBottom: 12, fontSize: 14 }}>
                                                    <strong>New Advisor (First Policy):</strong> in the exported CSV, <strong>EnrollmentDate</strong> is the later of the policy effective date and the created-at date (the created-at date is used when the policy has no effective date).
                                                </InfoBox>
                                                <div className="table-responsive">
                                                    <table className="table table-striped table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th style={{ textAlign: 'right' }}>Rate</th>
                                                                <th style={{ textAlign: 'right' }}><span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>{regionDisplayName} <CustomToolTip header={regionDisplayName} bodyContent={regionTooltip} /></span></th>
                                                                <th style={{ textAlign: 'right' }}>{regionDisplayName} Total</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ whiteSpace: 'nowrap' }}>
                                                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Reactivation - No New Enrollment in the last 24m <CustomToolTip header="Reactivation - No New Enrollment in the last 24m" bodyContent="Advisors with a policy created this month, at least one policy created 24+ months ago, and none created in the 24 months between. Based on policy creation date - cancelled policies still count as enrollments." /></span>
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>$137.50</td>
                                                                <td style={{ textAlign: 'right' }}>{reactivationCount}</td>
                                                                <td style={{ textAlign: 'right' }}>${(reactivationCount * 137.5).toFixed(2)}</td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    <button className="btn btn-link btn-sm p-0" title="Download detail"
                                                                        onClick={() => this.downloadActivityDetailFiltered('reactivation', 'advisor_reactivation')}>
                                                                        <Download size={14} style={{ opacity: 0.6 }} />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ whiteSpace: 'nowrap' }}>
                                                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Reactivation - No Prior Enrollment <CustomToolTip header="Reactivation - No Prior Enrollment" bodyContent="Advisors registered before Jan 1 2026 whose first-ever policy was created this month. Based on policy creation date - cancelled policies still count." /></span>
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>$137.50</td>
                                                                <td style={{ textAlign: 'right' }}>{noPriorCount}</td>
                                                                <td style={{ textAlign: 'right' }}>${(noPriorCount * 137.5).toFixed(2)}</td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    <button className="btn btn-link btn-sm p-0" title="Download detail"
                                                                        onClick={() => this.downloadActivityDetailFiltered('noPrior', 'reactivation_no_prior')}>
                                                                        <Download size={14} style={{ opacity: 0.6 }} />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ whiteSpace: 'nowrap' }}>
                                                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>New Advisor (First Policy) <CustomToolTip header="New Advisor (First Policy)" bodyContent="Starting from January 1 2026" /></span>
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>$412.50</td>
                                                                <td style={{ textAlign: 'right' }}>{newAdvisorCount}</td>
                                                                <td style={{ textAlign: 'right' }}>${(newAdvisorCount * 412.5).toFixed(2)}</td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    <button className="btn btn-link btn-sm p-0" title="Download detail"
                                                                        onClick={() => this.downloadActivityDetailFiltered('newAdvisor', 'new_advisor')}>
                                                                        <Download size={14} style={{ opacity: 0.6 }} />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ whiteSpace: 'nowrap' }}>
                                                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Enrollment Volume <CustomToolTip header="Enrollment Volume" bodyContent="Policies created in this period (by creation date), including cancelled and not-yet-activated policies. A policy assigned to one region counts 1; a policy assigned to two regions counts 0.5 to each." /></span>
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>$12.22</td>
                                                                <td style={{ textAlign: 'right' }}>{enrollmentVolumeCount}</td>
                                                                <td style={{ textAlign: 'right' }}>${(enrollmentVolumeCount * 12.22).toFixed(2)}</td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    <button className="btn btn-link btn-sm p-0" title="Download detail"
                                                                        onClick={() => this.downloadActivityDetailFiltered('policyCount', 'policy_count')}>
                                                                        <Download size={14} style={{ opacity: 0.6 }} />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        );
                                    })()}

                                    {/* advisor reactivation (region-filtered) */}
                                    {(() => {
                                        const salesFilteredReactivation = this.getSalesFilteredReactivationList();
                                        const salesReactivationCsvData = salesFilteredReactivation.map(item => ({
                                            "Agent ID": item.advisorId,
                                            "Advisor Name": item.advisorName,
                                            "Distro Account": item.distroName,
                                            "Advisor Province": item.province,
                                            "Advisor Enrollment Date": item.advisorCreatedAt
                                                ? new Date(item.advisorCreatedAt).toISOString().split('T')[0]
                                                : '',
                                            "First Policy Enrollment": item.firstEnrollment
                                                ? new Date(item.firstEnrollment).toISOString().split('T')[0]
                                                : '',
                                            "Most Recent Enrollment": item.mostRecentEnrollment
                                                ? new Date(item.mostRecentEnrollment).toISOString().split('T')[0]
                                                : '',
                                            "Months Since Last Enrollment": item.monthsSinceLastEnrollment != null
                                                ? item.monthsSinceLastEnrollment
                                                : 'Never',
                                            "Enrollments (24 mo)": item.enrollments24,
                                            "Enrollments (25+ mo)": item.enrollments25Plus,
                                            "Status": item.status,
                                        }));

                                        return this.state.loadingReactivation ? (
                                            <Spinner animation="border" />
                                        ) : (
                                            <>
                                                <div className="dashboard-toolbar">
                                                    <div className="dashboard-summary-header">
                                                        Advisor Reactivation
                                                    </div>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <label className="mb-0">Status:</label>
                                                        <select
                                                            className="form-select"
                                                            style={{ width: 'auto' }}
                                                            value={this.state.salesReactivationStatusFilter}
                                                            onChange={(e) => this.setState({ salesReactivationStatusFilter: e.target.value, currentPageSalesReactivation: 1 })}
                                                        >
                                                            <option value="ALL">All</option>
                                                            <option value="Active">Active</option>
                                                            <option value="Dormant">Dormant</option>
                                                        </select>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <label className="mb-0">Months Since Last:</label>
                                                        <select
                                                            className="form-select"
                                                            style={{ width: 'auto' }}
                                                            value={this.state.salesReactivationMonthsFilter}
                                                            onChange={(e) => this.setState({ salesReactivationMonthsFilter: e.target.value, currentPageSalesReactivation: 1 })}
                                                        >
                                                            <option value="ALL">All</option>
                                                            <option value="NEVER">Never</option>
                                                            <option value="12">Within 12 Months</option>
                                                            <option value="24">Within 24 Months</option>
                                                            <option value="25+">25+ Months</option>
                                                        </select>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-2 ms-auto">
                                                        {salesReactivationCsvData.length > 0 && (
                                                            <CSVLink data={salesReactivationCsvData} filename="advisor_reactivation.csv" style={{ textDecoration: 'none' }}>
                                                                <Button variant="outline-primary">
                                                                    Export to CSV
                                                                </Button>
                                                            </CSVLink>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="dashboard-table-container">
                                                    <div className="table-responsive">
                                                        <table className="table table-striped table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReactivationSort('advisorId')}>
                                                                        Agent ID {this.state.salesReactivationSortColumn === 'advisorId' ? (this.state.salesReactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                    </th>
                                                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReactivationSort('advisorName')}>
                                                                        Advisor Name {this.state.salesReactivationSortColumn === 'advisorName' ? (this.state.salesReactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                    </th>
                                                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReactivationSort('distroName')}>
                                                                        Distro Account {this.state.salesReactivationSortColumn === 'distroName' ? (this.state.salesReactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                    </th>
                                                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReactivationSort('province')}>
                                                                        Advisor Province {this.state.salesReactivationSortColumn === 'province' ? (this.state.salesReactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                    </th>
                                                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReactivationSort('advisorCreatedAt')}>
                                                                        Advisor Enrollment Date {this.state.salesReactivationSortColumn === 'advisorCreatedAt' ? (this.state.salesReactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                    </th>
                                                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReactivationSort('firstEnrollment')}>
                                                                        First Policy Enrollment {this.state.salesReactivationSortColumn === 'firstEnrollment' ? (this.state.salesReactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                    </th>
                                                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReactivationSort('mostRecentEnrollment')}>
                                                                        Most Recent Enrollment {this.state.salesReactivationSortColumn === 'mostRecentEnrollment' ? (this.state.salesReactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                    </th>
                                                                    <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReactivationSort('monthsSinceLastEnrollment')}>
                                                                        Months Since Last {this.state.salesReactivationSortColumn === 'monthsSinceLastEnrollment' ? (this.state.salesReactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                    </th>
                                                                    <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReactivationSort('enrollments24')}>
                                                                        Enrollments (24 mo) {this.state.salesReactivationSortColumn === 'enrollments24' ? (this.state.salesReactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                    </th>
                                                                    <th className="text-end" style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReactivationSort('enrollments25Plus')}>
                                                                        Enrollments (25+ mo) {this.state.salesReactivationSortColumn === 'enrollments25Plus' ? (this.state.salesReactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                    </th>
                                                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSalesReactivationSort('status')}>
                                                                        Status {this.state.salesReactivationSortColumn === 'status' ? (this.state.salesReactivationSortDirection === 'asc' ? '↑' : '↓') : ''}
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.currentSalesReactivationRecords().map((data, index) => (
                                                                    <tr key={index}>
                                                                        <td>{data.advisorId}</td>
                                                                        <td>{data.advisorName}</td>
                                                                        <td>{data.distroName}</td>
                                                                        <td>{data.province}</td>
                                                                        <td>{data.advisorCreatedAt ? new Date(data.advisorCreatedAt).toISOString().split('T')[0] : ''}</td>
                                                                        <td>{data.firstEnrollment ? new Date(data.firstEnrollment).toISOString().split('T')[0] : ''}</td>
                                                                        <td>{data.mostRecentEnrollment ? new Date(data.mostRecentEnrollment).toISOString().split('T')[0] : ''}</td>
                                                                        <td className="text-end">{data.monthsSinceLastEnrollment != null ? data.monthsSinceLastEnrollment : 'Never'}</td>
                                                                        <td className="text-end">{data.enrollments24}</td>
                                                                        <td className="text-end">{data.enrollments25Plus}</td>
                                                                        <td>
                                                                            <span style={{
                                                                                color: data.status === 'Active' ? '#059454' : '#dc3545',
                                                                                fontWeight: 600,
                                                                            }}>
                                                                                {data.status}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="pagination-container" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 12, flexWrap: 'wrap', paddingBottom: 16 }}>
                                                    <div className="pagination-info">
                                                        <span>Showing {salesFilteredReactivation.length > 0 ? this.state.currentPageSalesReactivation * this.state.salesReactivationItemsPerPage - this.state.salesReactivationItemsPerPage + 1 : 0} - {Math.min(this.state.currentPageSalesReactivation * this.state.salesReactivationItemsPerPage, salesFilteredReactivation.length)} entries out of {salesFilteredReactivation.length} entries</span>
                                                    </div>
                                                    <CustomPagination
                                                        nPages={this.nPages(salesFilteredReactivation.length, this.state.salesReactivationItemsPerPage)}
                                                        currentPage={this.state.currentPageSalesReactivation}
                                                        setCurrentPage={this.setSalesReactivationCurrentPage}
                                                    />
                                                </div>
                                            </>
                                        );
                                    })()}
                                </>
                            )}
                        </div>
                    </div>
                );
            } else {
                currentContents = (
                    <div className="card-body">
                        <div className="db-daily">
                            {this.state.loadingDaily ? (
                                <Spinner animation="border"/>
                            ) : (
                                <>
                                    <div className="dashboard-summary-header">Daily Summary</div>

                                    <div className="row mt-4">
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <ClipboardList size={14}/> QUEUED
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {this.state.reportDaily.dailyQueued}
                                                </div>
                                                <div>Queued Claims</div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <Clock size={14}/> NEW
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {this.state.reportDaily.dailyNew}
                                                </div>
                                                <div>New Claims</div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <Clock size={14}/> PENDING
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {this.state.reportDaily.dailyPending}
                                                </div>
                                                <div>Pending Claims</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <ClipboardList size={14}/> CREATED
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {this.state.reportDaily.createdClaimCount}
                                                </div>
                                                <div>Created Claims</div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <ImageIcon size={14}/> IMAGES
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {this.state.reportDaily.createdImageCount}
                                                </div>
                                                <div>Created Images</div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <CheckCircle size={14}/> PROCESSED
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {this.state.reportDaily.processedClaimCount}
                                                </div>
                                                <div>Processed Claims</div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-12">
                                            <div className="dashboard-summary-card">
                                                <div className="dashboard-card-icon">
                                                    <ImageIcon size={14}/> PROCESSED
                                                </div>
                                                <div className="dashboard-summary-value">
                                                    {this.state.reportDaily.processedImageCount}
                                                </div>
                                                <div>Processed Images</div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        <div className="db-claims">
                            {this.state.loadingClaims ? (
                                <Spinner animation="border"/>
                            ) : this.state.reportClaims == null ? (
                                <div className="text-muted">Unable to load claims data</div>
                            ) : (
                                <>
                                    <div className="dashboard-toolbar">
                                        <div className="dashboard-summary-header">
                                            Claim Summary
                                        </div>
                                        <div className="d-flex align-items-center gap-2 ms-auto">
                                            <CustomDateRangePicker
                                                fromDate={this.state.fromDate}
                                                toDate={this.state.toDate}
                                                setFromDate={this.setFromDate}
                                                setToDate={this.setToDate}
                                            />
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                onClick={this.applyClaimsFilter}
                                            >
                                                Apply
                                            </Button>
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                                            <div className="dashboard-summary-header" style={{fontSize: 14}}>
                                                Paid & Pending Payment Claims
                                                <CustomToolTip
                                                    header="Paid + Pending Payment"
                                                    bodyContent="Combined total of Paid and Pending Payment claims. Paid claims are counted by their disbursement date, while Pending Payment (processed but not yet disbursed) claims are counted by their approval date."
                                                />
                                            </div>
                                            <div style={{
                                                fontWeight: 600,
                                                color: "#1e85e5",
                                                background: "#eaf3fd",
                                                border: "1px solid #bcdcf8",
                                                padding: "4px 12px",
                                                borderRadius: 16,
                                            }}>
                                                Combined: {formatCount(this.state.reportClaims.paidAndAdjudicatedCount)} claims · {formatCurrency(this.state.reportClaims.paidAndAdjudicatedAmount)}
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-md-3 col-sm-12">
                                                <div className="dashboard-summary-card">
                                                    <div className="dashboard-card-icon">
                                                        <TrendingUp size={14}/> # PAID Claims
                                                        <CustomToolTip
                                                            header="# Paid Claims"
                                                            bodyContent="Claims actually funded (disbursed) within the selected dates — counted by disbursement date, not approval date."
                                                        />
                                                    </div>
                                                    <div className="dashboard-summary-value">
                                                        {formatCount(this.state.reportClaims.paidCount)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-12">
                                                <div className="dashboard-summary-card">
                                                    <div className="dashboard-card-icon">
                                                        <TrendingUp size={14}/> Paid Claims Total Amount
                                                        <CustomToolTip
                                                            header="Paid Claims Total Amount"
                                                            bodyContent="Total dollars actually funded (disbursed) within the selected dates, counted by disbursement date."
                                                        />
                                                    </div>
                                                    <div className="dashboard-summary-value">
                                                        {formatCurrency(this.state.reportClaims.paidAmount)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-12">
                                                <div className="dashboard-summary-card">
                                                    <div className="dashboard-card-icon">
                                                        <ClipboardList size={14}/> # of PENDING PAYMENT Claims
                                                        <CustomToolTip
                                                            header="# Pending Payment Claims"
                                                            bodyContent="Claims processed within the selected dates but not yet funded — counted by approval date."
                                                        />
                                                    </div>
                                                    <div className="dashboard-summary-value">
                                                        {formatCount(this.state.reportClaims.unpaidCount)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-12">
                                                <div className="dashboard-summary-card">
                                                    <div className="dashboard-card-icon">
                                                        <ClipboardList size={14}/> Pending Payment Claims Total Amount
                                                        <CustomToolTip
                                                            header="Pending Payment Claims Total Amount"
                                                            bodyContent="Total processed dollars not yet funded, counted by approval date within the selected dates."
                                                        />
                                                    </div>
                                                    <div className="dashboard-summary-value">
                                                        {formatCurrency(this.state.reportClaims.unpaidAmount)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <div className="dashboard-summary-header" style={{fontSize: 14}}>
                                            Processed Claims
                                            <CustomToolTip
                                                header="Processed Claims"
                                                bodyContent="Total claims processed during this period. Includes rejected claims."
                                            />
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-md-3 col-sm-12">
                                                <div className="dashboard-summary-card">
                                                    <div className="dashboard-card-icon">
                                                        <TrendingUp size={14}/> # Claims processed
                                                        <CustomToolTip
                                                            header="# Claims Processed"
                                                            bodyContent="All claims processed within the selected dates. Includes rejected claims."
                                                        />
                                                    </div>
                                                    <div className="dashboard-summary-value">
                                                        {formatCount(this.state.reportClaims.processedClaimsCount)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-12">
                                                <div className="dashboard-summary-card">
                                                    <div className="dashboard-card-icon">
                                                        <TrendingUp size={14}/> Total Processed Claims Amount
                                                        <CustomToolTip
                                                            header="Total Processed Claims Amount"
                                                            bodyContent="Total processed amounts for claims processed within the selected dates, counted by approval date."
                                                        />
                                                    </div>
                                                    <div className="dashboard-summary-value">
                                                        {formatCurrency(this.state.reportClaims.processedClaimsAmount)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-4">
                                        <div className="col-md-6 col-sm-12">
                                            <ResponsiveContainer width="100%" height={300}>
                                                <PieChart>
                                                    <Pie
                                                        data={accountTypeChart}
                                                        cx="50%"
                                                        cy="50%"
                                                        labelLine={false}
                                                        label={renderCustomizedLabel}
                                                        outerRadius={120}
                                                        fill="#8884d8"
                                                        dataKey="value"
                                                    >
                                                        {accountTypeChart.map((entry, index) => (
                                                            <Cell
                                                                key={`cell-${index}`}
                                                                fill={pieColors[index % pieColors.length]}
                                                            />
                                                        ))}
                                                    </Pie>
                                                </PieChart>
                                            </ResponsiveContainer>
                                            <div className="text-center">Paid Claims by Type</div>
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <ResponsiveContainer width="100%" height={300}>
                                                <PieChart>
                                                    <Pie
                                                        data={zeroPaidChart}
                                                        cx="50%"
                                                        cy="50%"
                                                        labelLine={false}
                                                        label={renderZeroPaidLabel}
                                                        outerRadius={120}
                                                        fill="#8884d8"
                                                        dataKey="value"
                                                    >
                                                        {zeroPaidChart.map((entry, index) => (
                                                            <Cell
                                                                key={`cell-${index}`}
                                                                fill={
                                                                    zeroPaidColors[index % zeroPaidColors.length]
                                                                }
                                                            />
                                                        ))}
                                                    </Pie>
                                                </PieChart>
                                            </ResponsiveContainer>
                                            <div className="text-center">
                                                Processed (Paid / $0 Paid)
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-4">
                                        <div className="col-md-12 col-sm-12">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="dashboard-summary-header">
                                                    Processed Claims (by Adjudicator)
                                                </div>
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    onClick={this.toggleAdjudicatorView}
                                                >
                                                    {this.state.adjudicatorViewMode === "table" ? "Show Chart" : "Show Table"}
                                                </Button>
                                            </div>

                                            {this.state.adjudicatorViewMode === "table" ? (
                                                <div className="dashboard-table-container">
                                                    <table className="table table-striped table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    style={{cursor: "pointer"}}
                                                                    onClick={() => this.handleAdjudicatorSort("name")}
                                                                >
                                                                    Adjudicator Name
                                                                    {this.state.adjudicatorSortColumn === "name" && (
                                                                        <span className="ms-1">
                                                                            {this.state.adjudicatorSortDirection === "asc" ? "▲" : "▼"}
                                                                        </span>
                                                                    )}
                                                                </th>
                                                                <th
                                                                    style={{cursor: "pointer"}}
                                                                    onClick={() => this.handleAdjudicatorSort("totalProcessed")}
                                                                >
                                                                    Total Processed
                                                                    {this.state.adjudicatorSortColumn === "totalProcessed" && (
                                                                        <span className="ms-1">
                                                                            {this.state.adjudicatorSortDirection === "asc" ? "▲" : "▼"}
                                                                        </span>
                                                                    )}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.getSortedAdjudicatorTotals().map((adj, index) => (
                                                                <tr key={index}>
                                                                    <td>{adj.name}</td>
                                                                    <td>{adj.totalProcessed}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <ResponsiveContainer width="100%" height={420}>
                                                    <BarChart
                                                        data={adjudicationTotalsChart}
                                                        margin={{
                                                            top: 20,
                                                            right: 30,
                                                            left: 20,
                                                            bottom: 30,
                                                        }}
                                                    >
                                                        <CartesianGrid strokeDasharray="3 3"/>
                                                        <XAxis dataKey="name"/>
                                                        <YAxis/>
                                                        <Tooltip/>
                                                        <Legend/>
                                                        <Bar dataKey="totalPaid" name="Paid" stackId="a" fill="#059454"/>
                                                        <Bar dataKey="totalAdjudicated" name="Adjudicated" stackId="a" fill="#4178be"/>
                                                        <Bar
                                                            dataKey="totalZeroPaid"
                                                            name="$0 Paid"
                                                            stackId="a"
                                                            fill="#dc3545"
                                                        />
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            )}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        <div className="db-claims">
                            <AdjudicationSlaReport/>
                        </div>
                    </div>
                );
            }

            return (
                this.state.userValidated &&
                    <div style={{width: "100%", padding: "16px"}}>
                        <div className="container-fluid">
                            <div className="card mt-3 shadow-sm" style={{border: 'none', borderRadius: 12}}>
                                <ul className="dashboard-nav-tabs">
                                    {(this.state.userRole === "Finance" || this.state.userRole === "DataImplementation") &&
                                        <li className="nav-item">
                                            <a className={`dashboard-tab ${this.state.currentTab === "leadership" ? "active" : ""}`}
                                               onClick={() => this.setTab("leadership")}
                                               href="#">
                                                <BarChart3 size={16} style={{marginRight: 6}} />
                                                Leadership Metrics
                                            </a>
                                        </li>
                                    }
                                    {this.state.userRole === "Sales" &&
                                        <li className="nav-item">
                                            <a className={`dashboard-tab ${this.state.currentTab === "salesReports" ? "active" : ""}`}
                                               onClick={() => this.setTab("salesReports")}
                                               href="#">
                                                <BarChart3 size={16} style={{marginRight: 6}} />
                                                Sales Reports
                                            </a>
                                        </li>
                                    }
                                    {this.state.userRole !== "Sales" &&
                                        <li className="nav-item">
                                            <a className={`dashboard-tab ${this.state.currentTab === "adjudication" ? "active" : ""}`}
                                               onClick={() => this.setTab("adjudication")}
                                               href="#">
                                                <ClipboardList size={16} style={{marginRight: 6}} />
                                                Claims & Adjudication
                                            </a>
                                        </li>
                                    }
                                    {(this.state.userRole === "Finance" || this.state.userRole === "FinanceSupport" || this.state.userRole === "Sales" || this.state.userRole === "DataImplementation") &&
                                        <li className="nav-item">
                                            <a className={`dashboard-tab ${this.state.currentTab === "financials" ? "active" : ""}`}
                                               onClick={() => this.setTab("financials")}
                                               href="#">
                                                <TrendingUp size={16} style={{marginRight: 6}} />
                                                Financials
                                            </a>
                                        </li>
                                    }
                                    {(this.state.userRole === "Finance" || this.state.userRole === "FinanceSupport" || this.state.userRole === "Sales" || this.state.userRole === "DataImplementation") &&
                                        <li className="nav-item">
                                            <a className={`dashboard-tab ${this.state.currentTab === "policy" ? "active" : ""}`}
                                               onClick={() => this.setTab("policy")}
                                               href="#">
                                                <FileText size={16} style={{marginRight: 6}} />
                                                Policies & Enrollments
                                            </a>
                                        </li>
                                    }
                                    {(this.state.userRole === "Finance" || this.state.userRole === "FinanceSupport" || this.state.userRole === "Sales" || this.state.userRole === "DataImplementation") &&
                                        <li className="nav-item">
                                            <a className={`dashboard-tab ${this.state.currentTab === "advisors" ? "active" : ""}`}
                                               onClick={() => this.setTab("advisors")}
                                               href="#">
                                                <Users size={16} style={{marginRight: 6}} />
                                                Advisors
                                            </a>
                                        </li>
                                    }
                                    {(this.state.userRole === "Finance" || this.state.userRole === "FinanceSupport" || this.state.userRole === "DataImplementation") &&
                                        <li className="nav-item">
                                            <a className={`dashboard-tab ${this.state.currentTab === "commissions" ? "active" : ""}`}
                                               onClick={() => this.setTab("commissions")}
                                               href="#">
                                                <DollarSign size={16} style={{marginRight: 6}} />
                                                Sales Commissions
                                            </a>
                                        </li>
                                    }
                                </ul>
                                {this.state.mountedTabs["financials"] &&
                                    <div className="card-body" style={{display: this.state.currentTab === "financials" ? undefined : "none"}}>
                                        <div className="db-claims">
                                            <OpsFinancialsReport/>
                                        </div>
                                    </div>
                                }
                                {this.state.mountedTabs["leadership"] &&
                                    <div className="card-body" style={{display: this.state.currentTab === "leadership" ? undefined : "none"}}>
                                        <div className="db-claims">
                                            <LeadershipMetricsReport/>
                                        </div>
                                    </div>
                                }
                                {currentContents}
                            </div>
                        </div>
                    </div>
            );
        }
    }
);
